import { K as he, k as de, i as Q, e as F, f as te, _ as W, c as Mn, q as Ut, d as Nt, h as oe, m as nt, C as gi, D as hi, o as bi, n as Ci, E as yi, F as Ei, G as U, T as tr, H as Tr, j as A, a as Ar, v as Si } from "./country-de01c755.js";
import * as l from "react";
import ve, { useState as Me, useMemo as Cn, useCallback as ze, forwardRef as Pn, useRef as pt, useImperativeHandle as Br, useContext as nr, useEffect as Pe, createContext as $i } from "react";
import { u as rt, b as xt, c as ot } from "./index-52459974.js";
import { C as Ii, a as it, A as Qt, b as wi, g as _i, t as Ni, c as Dr, m as yn, d as rr, r as Lr, e as Oi, u as Kr, f as jr, h as Ur, j as or, k as xi, z as Ri, i as Re, q as Mi, l as Pi } from "./lib-b7ffbdee.js";
import { i as kr, R as zr, T as Hr, o as Rt, t as Fr, e as Zt, f as Vr, N as Ti, g as Wr, h as Ai, j as Bi, k as Di, m as Li, n as Ki, C as ji, p as Ui, q as ki, r as ir, s as zi, A as Hi, E as Fi, F as Vi, G as Wi, v as Gi, w as Xi, X as Yi, M as qi } from "./index-e7ddceda.js";
import { d as Qi, c as Mt, B as Gr, f as Zi } from "./broadcast-channel-624075a4.js";
import { S as Ee, s as Jt, A as Ji, F as ea, G as ta, g as Xr, a as en, L as Ft, b as ar, c as na, d as ra, e as Yr, f as tn, o as En, r as nn, h as qr, i as oa, T as Vt, j as lr, k as Qr, l as ia } from "./helper-6945ecce.js";
import { k as Zr } from "./reactNode-0a48f959.js";
const aa = (e) => ({
  [e.componentCls]: {
    // For common/openAnimation
    [`${e.antCls}-motion-collapse-legacy`]: {
      overflow: "hidden",
      "&-active": {
        transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
      }
    },
    [`${e.antCls}-motion-collapse`]: {
      overflow: "hidden",
      transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
    }
  }
}), la = aa, sa = new he("antMoveDownIn", {
  "0%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), ca = new he("antMoveDownOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), ua = new he("antMoveLeftIn", {
  "0%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), da = new he("antMoveLeftOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), fa = new he("antMoveRightIn", {
  "0%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), ma = new he("antMoveRightOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), pa = new he("antMoveUpIn", {
  "0%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), va = new he("antMoveUpOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), ga = {
  "move-up": {
    inKeyframes: pa,
    outKeyframes: va
  },
  "move-down": {
    inKeyframes: sa,
    outKeyframes: ca
  },
  "move-left": {
    inKeyframes: ua,
    outKeyframes: da
  },
  "move-right": {
    inKeyframes: fa,
    outKeyframes: ma
  }
}, sr = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: o,
    outKeyframes: a
  } = ga[t];
  return [kr(r, o, a, e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, Jr = new he("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), eo = new he("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), to = new he("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), no = new he("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), ha = new he("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), ba = new he("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), Ca = new he("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), ya = new he("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), Ea = {
  "slide-up": {
    inKeyframes: Jr,
    outKeyframes: eo
  },
  "slide-down": {
    inKeyframes: to,
    outKeyframes: no
  },
  "slide-left": {
    inKeyframes: ha,
    outKeyframes: ba
  },
  "slide-right": {
    inKeyframes: Ca,
    outKeyframes: ya
  }
}, Wt = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: o,
    outKeyframes: a
  } = Ea[t];
  return [kr(r, o, a, e.motionDurationMid), {
    [`
      ${r}-enter,
      ${r}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutQuint,
      "&-prepare": {
        transform: "scale(1)"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInQuint
    }
  }];
};
function Sa(e) {
  return (t) => /* @__PURE__ */ l.createElement(Ii, {
    theme: {
      token: {
        motion: !1,
        zIndexPopupBase: 0
      }
    }
  }, /* @__PURE__ */ l.createElement(e, Object.assign({}, t)));
}
const $a = (e, t, n, r) => Sa((a) => {
  const {
    prefixCls: i,
    style: s
  } = a, c = l.useRef(null), [f, S] = l.useState(0), [d, g] = l.useState(0), [y, h] = Zr(!1, {
    value: a.open
  }), {
    getPrefixCls: m
  } = l.useContext(it), b = m(t || "select", i);
  l.useEffect(() => {
    if (h(!0), typeof ResizeObserver < "u") {
      const v = new ResizeObserver(($) => {
        const I = $[0].target;
        S(I.offsetHeight + 8), g(I.offsetWidth);
      }), p = setInterval(() => {
        var $;
        const I = n ? `.${n(b)}` : `.${b}-dropdown`, E = ($ = c.current) === null || $ === void 0 ? void 0 : $.querySelector(I);
        E && (clearInterval(p), v.observe(E));
      }, 10);
      return () => {
        clearInterval(p), v.disconnect();
      };
    }
  }, []);
  let u = Object.assign(Object.assign({}, a), {
    style: Object.assign(Object.assign({}, s), {
      margin: 0
    }),
    open: y,
    visible: y,
    getPopupContainer: () => c.current
  });
  r && (u = r(u));
  const C = {
    paddingBottom: f,
    position: "relative",
    minWidth: d
  };
  return /* @__PURE__ */ l.createElement("div", {
    ref: c,
    style: C
  }, /* @__PURE__ */ l.createElement(e, Object.assign({}, u)));
}), Ia = $a;
function wa() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var cr = process.env.NODE_ENV !== "test" && wa() ? l.useLayoutEffect : l.useEffect, _a = function(t, n) {
  var r = l.useRef(!0);
  cr(function() {
    return t(r.current);
  }, n), cr(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
}, Na = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], dt = void 0;
function Oa(e, t) {
  var n = e.prefixCls, r = e.invalidate, o = e.item, a = e.renderItem, i = e.responsive, s = e.responsiveDisabled, c = e.registerSize, f = e.itemKey, S = e.className, d = e.style, g = e.children, y = e.display, h = e.order, m = e.component, b = m === void 0 ? "div" : m, u = de(e, Na), C = i && !y;
  function v(N) {
    c(f, N);
  }
  l.useEffect(function() {
    return function() {
      v(null);
    };
  }, []);
  var p = a && o !== dt ? a(o) : g, $;
  r || ($ = {
    opacity: C ? 0 : 1,
    height: C ? 0 : dt,
    overflowY: C ? "hidden" : dt,
    order: i ? h : dt,
    pointerEvents: C ? "none" : dt,
    position: C ? "absolute" : dt
  });
  var I = {};
  C && (I["aria-hidden"] = !0);
  var E = /* @__PURE__ */ l.createElement(b, Q({
    className: F(!r && n, S),
    style: te(te({}, $), d)
  }, I, u, {
    ref: t
  }), p);
  return i && (E = /* @__PURE__ */ l.createElement(zr, {
    onResize: function(_) {
      var O = _.offsetWidth;
      v(O);
    },
    disabled: s
  }, E)), E;
}
var _t = /* @__PURE__ */ l.forwardRef(Oa);
_t.displayName = "Item";
function xa(e) {
  var t = l.useRef();
  t.current = e;
  var n = l.useCallback(function() {
    for (var r, o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(a));
  }, []);
  return n;
}
var ro = function(t) {
  return +setTimeout(t, 16);
}, oo = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (ro = function(t) {
  return window.requestAnimationFrame(t);
}, oo = function(t) {
  return window.cancelAnimationFrame(t);
});
var ur = 0, rn = /* @__PURE__ */ new Map();
function io(e) {
  rn.delete(e);
}
var Tn = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  ur += 1;
  var r = ur;
  function o(a) {
    if (a === 0)
      io(r), t();
    else {
      var i = ro(function() {
        o(a - 1);
      });
      rn.set(r, i);
    }
  }
  return o(n), r;
};
Tn.cancel = function(e) {
  var t = rn.get(e);
  return io(e), oo(t);
};
process.env.NODE_ENV !== "production" && (Tn.ids = function() {
  return rn;
});
function Ra(e) {
  if (typeof MessageChannel > "u")
    Tn(e);
  else {
    var t = new MessageChannel();
    t.port1.onmessage = function() {
      return e();
    }, t.port2.postMessage(void 0);
  }
}
function Ma() {
  var e = l.useRef(null), t = function(r) {
    e.current || (e.current = [], Ra(function() {
      Mn.unstable_batchedUpdates(function() {
        e.current.forEach(function(o) {
          o();
        }), e.current = null;
      });
    })), e.current.push(r);
  };
  return t;
}
function St(e, t) {
  var n = l.useState(t), r = W(n, 2), o = r[0], a = r[1], i = xa(function(s) {
    e(function() {
      a(s);
    });
  });
  return [o, i];
}
var Gt = /* @__PURE__ */ ve.createContext(null), Pa = ["component"], Ta = ["className"], Aa = ["className"], Ba = function(t, n) {
  var r = l.useContext(Gt);
  if (!r) {
    var o = t.component, a = o === void 0 ? "div" : o, i = de(t, Pa);
    return /* @__PURE__ */ l.createElement(a, Q({}, i, {
      ref: n
    }));
  }
  var s = r.className, c = de(r, Ta), f = t.className, S = de(t, Aa);
  return /* @__PURE__ */ l.createElement(Gt.Provider, {
    value: null
  }, /* @__PURE__ */ l.createElement(_t, Q({
    ref: n,
    className: F(s, f)
  }, c, S)));
}, ao = /* @__PURE__ */ l.forwardRef(Ba);
ao.displayName = "RawItem";
var Da = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], lo = "responsive", so = "invalidate";
function La(e) {
  return "+ ".concat(e.length, " ...");
}
function Ka(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-overflow" : n, o = e.data, a = o === void 0 ? [] : o, i = e.renderItem, s = e.renderRawItem, c = e.itemKey, f = e.itemWidth, S = f === void 0 ? 10 : f, d = e.ssr, g = e.style, y = e.className, h = e.maxCount, m = e.renderRest, b = e.renderRawRest, u = e.suffix, C = e.component, v = C === void 0 ? "div" : C, p = e.itemComponent, $ = e.onVisibleChange, I = de(e, Da), E = d === "full", N = Ma(), _ = St(N, null), O = W(_, 2), M = O[0], P = O[1], w = M || 0, x = St(N, /* @__PURE__ */ new Map()), B = W(x, 2), K = B[0], j = B[1], V = St(N, 0), k = W(V, 2), G = k[0], ne = k[1], L = St(N, 0), X = W(L, 2), q = X[0], Z = X[1], J = St(N, 0), ae = W(J, 2), ee = ae[0], fe = ae[1], le = Me(null), be = W(le, 2), me = be[0], z = be[1], pe = Me(null), ue = W(pe, 2), je = ue[0], ht = ue[1], Te = l.useMemo(function() {
    return je === null && E ? Number.MAX_SAFE_INTEGER : je || 0;
  }, [je, M]), Fe = Me(!1), Ve = W(Fe, 2), We = Ve[0], bt = Ve[1], Ge = "".concat(r, "-item"), Ue = Math.max(G, q), Se = h === lo, $e = a.length && Se, st = h === so, ct = $e || typeof h == "number" && a.length > h, Oe = Cn(function() {
    var D = a;
    return $e ? M === null && E ? D = a : D = a.slice(0, Math.min(a.length, w / S)) : typeof h == "number" && (D = a.slice(0, h)), D;
  }, [a, S, M, h, $e]), De = Cn(function() {
    return $e ? a.slice(Te + 1) : a.slice(Oe.length);
  }, [a, Oe, $e, Te]), Ie = ze(function(D, H) {
    var ce;
    return typeof c == "function" ? c(D) : (ce = c && (D == null ? void 0 : D[c])) !== null && ce !== void 0 ? ce : H;
  }, [c]), Le = ze(i || function(D) {
    return D;
  }, [i]);
  function xe(D, H, ce) {
    je === D && (H === void 0 || H === me) || (ht(D), ce || (bt(D < a.length - 1), $ == null || $(D)), H !== void 0 && z(H));
  }
  function Xe(D, H) {
    P(H.clientWidth);
  }
  function Ce(D, H) {
    j(function(ce) {
      var we = new Map(ce);
      return H === null ? we.delete(D) : we.set(D, H), we;
    });
  }
  function se(D, H) {
    Z(H), ne(q);
  }
  function At(D, H) {
    fe(H);
  }
  function Ye(D) {
    return K.get(Ie(Oe[D], D));
  }
  _a(function() {
    if (w && typeof Ue == "number" && Oe) {
      var D = ee, H = Oe.length, ce = H - 1;
      if (!H) {
        xe(0, null);
        return;
      }
      for (var we = 0; we < H; we += 1) {
        var ye = Ye(we);
        if (E && (ye = ye || 0), ye === void 0) {
          xe(we - 1, void 0, !0);
          break;
        }
        if (D += ye, // Only one means `totalWidth` is the final width
        ce === 0 && D <= w || // Last two width will be the final width
        we === ce - 1 && D + Ye(ce) <= w) {
          xe(ce, null);
          break;
        } else if (D + Ue > w) {
          xe(we - 1, D - ye - ee + q);
          break;
        }
      }
      u && Ye(0) + ee > w && z(null);
    }
  }, [w, K, q, ee, Ie, Oe]);
  var Bt = We && !!De.length, Ct = {};
  me !== null && $e && (Ct = {
    position: "absolute",
    left: me,
    top: 0
  });
  var qe = {
    prefixCls: Ge,
    responsive: $e,
    component: p,
    invalidate: st
  }, dn = s ? function(D, H) {
    var ce = Ie(D, H);
    return /* @__PURE__ */ l.createElement(Gt.Provider, {
      key: ce,
      value: te(te({}, qe), {}, {
        order: H,
        item: D,
        itemKey: ce,
        registerSize: Ce,
        display: H <= Te
      })
    }, s(D, H));
  } : function(D, H) {
    var ce = Ie(D, H);
    return /* @__PURE__ */ l.createElement(_t, Q({}, qe, {
      order: H,
      key: ce,
      item: D,
      renderItem: Le,
      itemKey: ce,
      registerSize: Ce,
      display: H <= Te
    }));
  }, Qe, Dt = {
    order: Bt ? Te : Number.MAX_SAFE_INTEGER,
    className: "".concat(Ge, "-rest"),
    registerSize: se,
    display: Bt
  };
  if (b)
    b && (Qe = /* @__PURE__ */ l.createElement(Gt.Provider, {
      value: te(te({}, qe), Dt)
    }, b(De)));
  else {
    var ut = m || La;
    Qe = /* @__PURE__ */ l.createElement(_t, Q({}, qe, Dt), typeof ut == "function" ? ut(De) : ut);
  }
  var ke = /* @__PURE__ */ l.createElement(v, Q({
    className: F(!st && r, y),
    style: g,
    ref: t
  }, I), Oe.map(dn), ct ? Qe : null, u && /* @__PURE__ */ l.createElement(_t, Q({}, qe, {
    responsive: Se,
    responsiveDisabled: !$e,
    order: Te,
    className: "".concat(Ge, "-suffix"),
    registerSize: At,
    display: !0,
    style: Ct
  }), u));
  return Se && (ke = /* @__PURE__ */ l.createElement(zr, {
    onResize: Xe,
    disabled: !$e
  }, ke)), ke;
}
var Ke = /* @__PURE__ */ l.forwardRef(Ka);
Ke.displayName = "Overflow";
Ke.Item = ao;
Ke.RESPONSIVE = lo;
Ke.INVALIDATE = so;
var ja = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" };
const Ua = ja;
var ka = function(t, n) {
  return /* @__PURE__ */ l.createElement(Qt, Q({}, t, {
    ref: n,
    icon: Ua
  }));
}, co = /* @__PURE__ */ l.forwardRef(ka);
process.env.NODE_ENV !== "production" && (co.displayName = "RightOutlined");
const Sn = co;
function za(e, t) {
  typeof e == "function" ? e(t) : Nt(e) === "object" && e && "current" in e && (e.current = t);
}
function uo() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t.filter(function(o) {
    return o;
  });
  return r.length <= 1 ? r[0] : function(o) {
    t.forEach(function(a) {
      za(a, o);
    });
  };
}
function fo(e) {
  var t, n, r = Ut.isMemo(e) ? e.type.type : e.type;
  return !(typeof r == "function" && !((t = r.prototype) !== null && t !== void 0 && t.render) && r.$$typeof !== Ut.ForwardRef || typeof e == "function" && !((n = e.prototype) !== null && n !== void 0 && n.render) && e.$$typeof !== Ut.ForwardRef);
}
var T = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var n = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= T.F1 && n <= T.F12)
      return !1;
    switch (n) {
      case T.ALT:
      case T.CAPS_LOCK:
      case T.CONTEXT_MENU:
      case T.CTRL:
      case T.DOWN:
      case T.END:
      case T.ESC:
      case T.HOME:
      case T.INSERT:
      case T.LEFT:
      case T.MAC_FF_META:
      case T.META:
      case T.NUMLOCK:
      case T.NUM_CENTER:
      case T.PAGE_DOWN:
      case T.PAGE_UP:
      case T.PAUSE:
      case T.PRINT_SCREEN:
      case T.RIGHT:
      case T.SHIFT:
      case T.UP:
      case T.WIN_KEY:
      case T.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= T.ZERO && t <= T.NINE || t >= T.NUM_ZERO && t <= T.NUM_MULTIPLY || t >= T.A && t <= T.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case T.SPACE:
      case T.QUESTION_MARK:
      case T.NUM_PLUS:
      case T.NUM_MINUS:
      case T.NUM_PERIOD:
      case T.NUM_DIVISION:
      case T.SEMICOLON:
      case T.DASH:
      case T.EQUALS:
      case T.COMMA:
      case T.PERIOD:
      case T.SLASH:
      case T.APOSTROPHE:
      case T.SINGLE_QUOTE:
      case T.OPEN_SQUARE_BRACKET:
      case T.BACKSLASH:
      case T.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, mo = function(t) {
  return +setTimeout(t, 16);
}, po = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (mo = function(t) {
  return window.requestAnimationFrame(t);
}, po = function(t) {
  return window.cancelAnimationFrame(t);
});
var dr = 0, on = /* @__PURE__ */ new Map();
function vo(e) {
  on.delete(e);
}
var An = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  dr += 1;
  var r = dr;
  function o(a) {
    if (a === 0)
      vo(r), t();
    else {
      var i = mo(function() {
        o(a - 1);
      });
      on.set(r, i);
    }
  }
  return o(n), r;
};
An.cancel = function(e) {
  var t = on.get(e);
  return vo(e), po(t);
};
process.env.NODE_ENV !== "production" && (An.ids = function() {
  return on;
});
var Ha = T.ESC, Fa = T.TAB;
function Va(e) {
  var t = e.visible, n = e.triggerRef, r = e.onVisibleChange, o = e.autoFocus, a = e.overlayRef, i = l.useRef(!1), s = function() {
    if (t) {
      var d, g;
      (d = n.current) === null || d === void 0 || (g = d.focus) === null || g === void 0 || g.call(d), r == null || r(!1);
    }
  }, c = function() {
    var d;
    return (d = a.current) !== null && d !== void 0 && d.focus ? (a.current.focus(), i.current = !0, !0) : !1;
  }, f = function(d) {
    switch (d.keyCode) {
      case Ha:
        s();
        break;
      case Fa: {
        var g = !1;
        i.current || (g = c()), g ? d.preventDefault() : s();
        break;
      }
    }
  };
  l.useEffect(function() {
    return t ? (window.addEventListener("keydown", f), o && An(c, 3), function() {
      window.removeEventListener("keydown", f), i.current = !1;
    }) : function() {
      i.current = !1;
    };
  }, [t]);
}
var Wa = /* @__PURE__ */ Pn(function(e, t) {
  var n = e.overlay, r = e.arrow, o = e.prefixCls, a = Cn(function() {
    var s;
    return typeof n == "function" ? s = n() : s = n, s;
  }, [n]), i = uo(t, a == null ? void 0 : a.ref);
  return /* @__PURE__ */ ve.createElement(ve.Fragment, null, r && /* @__PURE__ */ ve.createElement("div", {
    className: "".concat(o, "-arrow")
  }), /* @__PURE__ */ ve.cloneElement(a, {
    ref: fo(a) ? i : void 0
  }));
}), ft = {
  adjustX: 1,
  adjustY: 1
}, mt = [0, 0], Ga = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: ft,
    offset: [0, -4],
    targetOffset: mt
  },
  top: {
    points: ["bc", "tc"],
    overflow: ft,
    offset: [0, -4],
    targetOffset: mt
  },
  topRight: {
    points: ["br", "tr"],
    overflow: ft,
    offset: [0, -4],
    targetOffset: mt
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: ft,
    offset: [0, 4],
    targetOffset: mt
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: ft,
    offset: [0, 4],
    targetOffset: mt
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: ft,
    offset: [0, 4],
    targetOffset: mt
  }
}, Xa = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger", "autoFocus", "overlay", "children", "onVisibleChange"];
function Ya(e, t) {
  var n, r = e.arrow, o = r === void 0 ? !1 : r, a = e.prefixCls, i = a === void 0 ? "rc-dropdown" : a, s = e.transitionName, c = e.animation, f = e.align, S = e.placement, d = S === void 0 ? "bottomLeft" : S, g = e.placements, y = g === void 0 ? Ga : g, h = e.getPopupContainer, m = e.showAction, b = e.hideAction, u = e.overlayClassName, C = e.overlayStyle, v = e.visible, p = e.trigger, $ = p === void 0 ? ["hover"] : p, I = e.autoFocus, E = e.overlay, N = e.children, _ = e.onVisibleChange, O = de(e, Xa), M = ve.useState(), P = W(M, 2), w = P[0], x = P[1], B = "visible" in e ? v : w, K = ve.useRef(null), j = ve.useRef(null), V = ve.useRef(null);
  ve.useImperativeHandle(t, function() {
    return K.current;
  });
  var k = function(ee) {
    x(ee), _ == null || _(ee);
  };
  Va({
    visible: B,
    triggerRef: V,
    onVisibleChange: k,
    autoFocus: I,
    overlayRef: j
  });
  var G = function(ee) {
    var fe = e.onOverlayClick;
    x(!1), fe && fe(ee);
  }, ne = function() {
    return /* @__PURE__ */ ve.createElement(Wa, {
      ref: j,
      overlay: E,
      prefixCls: i,
      arrow: o
    });
  }, L = function() {
    return typeof E == "function" ? ne : ne();
  }, X = function() {
    var ee = e.minOverlayWidthMatchTrigger, fe = e.alignPoint;
    return "minOverlayWidthMatchTrigger" in e ? ee : !fe;
  }, q = function() {
    var ee = e.openClassName;
    return ee !== void 0 ? ee : "".concat(i, "-open");
  }, Z = /* @__PURE__ */ ve.cloneElement(N, {
    className: F((n = N.props) === null || n === void 0 ? void 0 : n.className, B && q()),
    ref: fo(N) ? uo(V, N.ref) : void 0
  }), J = b;
  return !J && $.indexOf("contextMenu") !== -1 && (J = ["click"]), /* @__PURE__ */ ve.createElement(Hr, Q({
    builtinPlacements: y
  }, O, {
    prefixCls: i,
    ref: K,
    popupClassName: F(u, oe({}, "".concat(i, "-show-arrow"), o)),
    popupStyle: C,
    action: $,
    showAction: m,
    hideAction: J,
    popupPlacement: d,
    popupAlign: f,
    popupTransitionName: s,
    popupAnimation: c,
    popupVisible: B,
    stretch: X() ? "minWidth" : "",
    popup: L(),
    onPopupVisibleChange: k,
    onPopupClick: G,
    getPopupContainer: h
  }), Z);
}
const qa = /* @__PURE__ */ ve.forwardRef(Ya);
function fr(e) {
  var t = l.useRef();
  t.current = e;
  var n = l.useCallback(function() {
    for (var r, o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(a));
  }, []);
  return n;
}
function Qa() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var mr = process.env.NODE_ENV !== "test" && Qa() ? l.useLayoutEffect : l.useEffect, Za = function(t, n) {
  var r = l.useRef(!0);
  mr(function() {
    return t(r.current);
  }, n), mr(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
}, pr = function(t, n) {
  Za(function(r) {
    if (!r)
      return t();
  }, n);
};
function vr(e) {
  var t = l.useRef(!1), n = l.useState(e), r = W(n, 2), o = r[0], a = r[1];
  l.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function i(s, c) {
    c && t.current || a(s);
  }
  return [o, i];
}
function gn(e) {
  return e !== void 0;
}
function kt(e, t) {
  var n = t || {}, r = n.defaultValue, o = n.value, a = n.onChange, i = n.postState, s = vr(function() {
    return gn(o) ? o : gn(r) ? typeof r == "function" ? r() : r : typeof e == "function" ? e() : e;
  }), c = W(s, 2), f = c[0], S = c[1], d = o !== void 0 ? o : f, g = i ? i(d) : d, y = fr(a), h = vr([d]), m = W(h, 2), b = m[0], u = m[1];
  pr(function() {
    var v = b[0];
    f !== v && y(f, v);
  }, [b]), pr(function() {
    gn(o) || S(o);
  }, [o]);
  var C = fr(function(v, p) {
    S(v, p), u([d], p);
  });
  return [g, C];
}
var $n = {}, Bn = [], Ja = function(t) {
  Bn.push(t);
};
function el(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0)
    var n = Bn.reduce(function(r, o) {
      return o(r ?? "", "warning");
    }, t);
}
function tl(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0)
    var n = Bn.reduce(function(r, o) {
      return o(r ?? "", "note");
    }, t);
}
function nl() {
  $n = {};
}
function go(e, t, n) {
  !t && !$n[n] && (e(!1, n), $n[n] = !0);
}
function Be(e, t) {
  go(el, e, t);
}
function rl(e, t) {
  go(tl, e, t);
}
Be.preMessage = Ja;
Be.resetWarned = nl;
Be.noteOnce = rl;
function ho(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = /* @__PURE__ */ new Set();
  function o(a, i) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, c = r.has(a);
    if (Be(!c, "Warning: There may be circular references"), c)
      return !1;
    if (a === i)
      return !0;
    if (n && s > 1)
      return !1;
    r.add(a);
    var f = s + 1;
    if (Array.isArray(a)) {
      if (!Array.isArray(i) || a.length !== i.length)
        return !1;
      for (var S = 0; S < a.length; S++)
        if (!o(a[S], i[S], f))
          return !1;
      return !0;
    }
    if (a && i && Nt(a) === "object" && Nt(i) === "object") {
      var d = Object.keys(a);
      return d.length !== Object.keys(i).length ? !1 : d.every(function(g) {
        return o(a[g], i[g], f);
      });
    }
    return !1;
  }
  return o(e, t);
}
var bo = /* @__PURE__ */ l.createContext(null);
function Co(e, t) {
  return e === void 0 ? null : "".concat(e, "-").concat(t);
}
function yo(e) {
  var t = l.useContext(bo);
  return Co(t, e);
}
function Eo(e, t, n) {
  var r = l.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
var ol = ["children", "locked"], Ae = /* @__PURE__ */ l.createContext(null);
function il(e, t) {
  var n = te({}, e);
  return Object.keys(t).forEach(function(r) {
    var o = t[r];
    o !== void 0 && (n[r] = o);
  }), n;
}
function Ot(e) {
  var t = e.children, n = e.locked, r = de(e, ol), o = l.useContext(Ae), a = Eo(function() {
    return il(o, r);
  }, [o, r], function(i, s) {
    return !n && (i[0] !== s[0] || !ho(i[1], s[1], !0));
  });
  return /* @__PURE__ */ l.createElement(Ae.Provider, {
    value: a
  }, t);
}
var al = [], So = /* @__PURE__ */ l.createContext(null);
function an() {
  return l.useContext(So);
}
var $o = /* @__PURE__ */ l.createContext(al);
function vt(e) {
  var t = l.useContext($o);
  return l.useMemo(function() {
    return e !== void 0 ? [].concat(nt(t), [e]) : t;
  }, [t, e]);
}
var Io = /* @__PURE__ */ l.createContext(null), Dn = /* @__PURE__ */ l.createContext({});
const ll = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), n = t.width, r = t.height;
      if (n || r)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var o = e.getBoundingClientRect(), a = o.width, i = o.height;
      if (a || i)
        return !0;
    }
  }
  return !1;
};
function gr(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (ll(e)) {
    var n = e.nodeName.toLowerCase(), r = (
      // Focusable element
      ["input", "select", "textarea", "button"].includes(n) || // Editable element
      e.isContentEditable || // Anchor with href element
      n === "a" && !!e.getAttribute("href")
    ), o = e.getAttribute("tabindex"), a = Number(o), i = null;
    return o && !Number.isNaN(a) ? i = a : r && i === null && (i = 0), r && e.disabled && (i = null), i !== null && (i >= 0 || t && i < 0);
  }
  return !1;
}
function sl(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = nt(e.querySelectorAll("*")).filter(function(r) {
    return gr(r, t);
  });
  return gr(e, t) && n.unshift(e), n;
}
var R = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var n = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= R.F1 && n <= R.F12)
      return !1;
    switch (n) {
      case R.ALT:
      case R.CAPS_LOCK:
      case R.CONTEXT_MENU:
      case R.CTRL:
      case R.DOWN:
      case R.END:
      case R.ESC:
      case R.HOME:
      case R.INSERT:
      case R.LEFT:
      case R.MAC_FF_META:
      case R.META:
      case R.NUMLOCK:
      case R.NUM_CENTER:
      case R.PAGE_DOWN:
      case R.PAGE_UP:
      case R.PAUSE:
      case R.PRINT_SCREEN:
      case R.RIGHT:
      case R.SHIFT:
      case R.UP:
      case R.WIN_KEY:
      case R.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= R.ZERO && t <= R.NINE || t >= R.NUM_ZERO && t <= R.NUM_MULTIPLY || t >= R.A && t <= R.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case R.SPACE:
      case R.QUESTION_MARK:
      case R.NUM_PLUS:
      case R.NUM_MINUS:
      case R.NUM_PERIOD:
      case R.NUM_DIVISION:
      case R.SEMICOLON:
      case R.DASH:
      case R.EQUALS:
      case R.COMMA:
      case R.PERIOD:
      case R.SLASH:
      case R.APOSTROPHE:
      case R.SINGLE_QUOTE:
      case R.OPEN_SQUARE_BRACKET:
      case R.BACKSLASH:
      case R.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, wo = function(t) {
  return +setTimeout(t, 16);
}, _o = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (wo = function(t) {
  return window.requestAnimationFrame(t);
}, _o = function(t) {
  return window.cancelAnimationFrame(t);
});
var hr = 0, ln = /* @__PURE__ */ new Map();
function No(e) {
  ln.delete(e);
}
var tt = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  hr += 1;
  var r = hr;
  function o(a) {
    if (a === 0)
      No(r), t();
    else {
      var i = wo(function() {
        o(a - 1);
      });
      ln.set(r, i);
    }
  }
  return o(n), r;
};
tt.cancel = function(e) {
  var t = ln.get(e);
  return No(e), _o(t);
};
process.env.NODE_ENV !== "production" && (tt.ids = function() {
  return ln;
});
var In = R.LEFT, wn = R.RIGHT, _n = R.UP, zt = R.DOWN, Ht = R.ENTER, Oo = R.ESC, $t = R.HOME, It = R.END, br = [_n, zt, In, wn];
function cl(e, t, n, r) {
  var o, a = "prev", i = "next", s = "children", c = "parent";
  if (e === "inline" && r === Ht)
    return {
      inlineTrigger: !0
    };
  var f = oe(oe({}, _n, a), zt, i), S = oe(oe(oe(oe({}, In, n ? i : a), wn, n ? a : i), zt, s), Ht, s), d = oe(oe(oe(oe(oe(oe({}, _n, a), zt, i), Ht, s), Oo, c), In, n ? s : c), wn, n ? c : s), g = {
    inline: f,
    horizontal: S,
    vertical: d,
    inlineSub: f,
    horizontalSub: d,
    verticalSub: d
  }, y = (o = g["".concat(e).concat(t ? "" : "Sub")]) === null || o === void 0 ? void 0 : o[r];
  switch (y) {
    case a:
      return {
        offset: -1,
        sibling: !0
      };
    case i:
      return {
        offset: 1,
        sibling: !0
      };
    case c:
      return {
        offset: -1,
        sibling: !1
      };
    case s:
      return {
        offset: 1,
        sibling: !1
      };
    default:
      return null;
  }
}
function ul(e) {
  for (var t = e; t; ) {
    if (t.getAttribute("data-menu-list"))
      return t;
    t = t.parentElement;
  }
  return null;
}
function dl(e, t) {
  for (var n = e || document.activeElement; n; ) {
    if (t.has(n))
      return n;
    n = n.parentElement;
  }
  return null;
}
function Ln(e, t) {
  var n = sl(e, !0);
  return n.filter(function(r) {
    return t.has(r);
  });
}
function Cr(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (!e)
    return null;
  var o = Ln(e, t), a = o.length, i = o.findIndex(function(s) {
    return n === s;
  });
  return r < 0 ? i === -1 ? i = a - 1 : i -= 1 : r > 0 && (i += 1), i = (i + a) % a, o[i];
}
var Nn = function(t, n) {
  var r = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  return t.forEach(function(i) {
    var s = document.querySelector("[data-menu-id='".concat(Co(n, i), "']"));
    s && (r.add(s), a.set(s, i), o.set(i, s));
  }), {
    elements: r,
    key2element: o,
    element2key: a
  };
};
function fl(e, t, n, r, o, a, i, s, c, f) {
  var S = l.useRef(), d = l.useRef();
  d.current = t;
  var g = function() {
    tt.cancel(S.current);
  };
  return l.useEffect(function() {
    return function() {
      g();
    };
  }, []), function(y) {
    var h = y.which;
    if ([].concat(br, [Ht, Oo, $t, It]).includes(h)) {
      var m = a(), b = Nn(m, r), u = b, C = u.elements, v = u.key2element, p = u.element2key, $ = v.get(t), I = dl($, C), E = p.get(I), N = cl(e, i(E, !0).length === 1, n, h);
      if (!N && h !== $t && h !== It)
        return;
      (br.includes(h) || [$t, It].includes(h)) && y.preventDefault();
      var _ = function(j) {
        if (j) {
          var V = j, k = j.querySelector("a");
          k != null && k.getAttribute("href") && (V = k);
          var G = p.get(j);
          s(G), g(), S.current = tt(function() {
            d.current === G && V.focus();
          });
        }
      };
      if ([$t, It].includes(h) || N.sibling || !I) {
        var O;
        !I || e === "inline" ? O = o.current : O = ul(I);
        var M, P = Ln(O, C);
        h === $t ? M = P[0] : h === It ? M = P[P.length - 1] : M = Cr(O, C, I, N.offset), _(M);
      } else if (N.inlineTrigger)
        c(E);
      else if (N.offset > 0)
        c(E, !0), g(), S.current = tt(function() {
          b = Nn(m, r);
          var K = I.getAttribute("aria-controls"), j = document.getElementById(K), V = Cr(j, b.elements);
          _(V);
        }, 5);
      else if (N.offset < 0) {
        var w = i(E, !0), x = w[w.length - 2], B = v.get(x);
        c(x, !1), _(B);
      }
    }
    f == null || f(y);
  };
}
function ml(e) {
  Promise.resolve().then(e);
}
var Kn = "__RC_UTIL_PATH_SPLIT__", yr = function(t) {
  return t.join(Kn);
}, pl = function(t) {
  return t.split(Kn);
}, On = "rc-menu-more";
function vl() {
  var e = l.useState({}), t = W(e, 2), n = t[1], r = pt(/* @__PURE__ */ new Map()), o = pt(/* @__PURE__ */ new Map()), a = l.useState([]), i = W(a, 2), s = i[0], c = i[1], f = pt(0), S = pt(!1), d = function() {
    S.current || n({});
  }, g = ze(function(v, p) {
    process.env.NODE_ENV !== "production" && Be(!r.current.has(v), "Duplicated key '".concat(v, "' used in Menu by path [").concat(p.join(" > "), "]"));
    var $ = yr(p);
    o.current.set($, v), r.current.set(v, $), f.current += 1;
    var I = f.current;
    ml(function() {
      I === f.current && d();
    });
  }, []), y = ze(function(v, p) {
    var $ = yr(p);
    o.current.delete($), r.current.delete(v);
  }, []), h = ze(function(v) {
    c(v);
  }, []), m = ze(function(v, p) {
    var $ = r.current.get(v) || "", I = pl($);
    return p && s.includes(I[0]) && I.unshift(On), I;
  }, [s]), b = ze(function(v, p) {
    return v.some(function($) {
      var I = m($, !0);
      return I.includes(p);
    });
  }, [m]), u = function() {
    var p = nt(r.current.keys());
    return s.length && p.push(On), p;
  }, C = ze(function(v) {
    var p = "".concat(r.current.get(v)).concat(Kn), $ = /* @__PURE__ */ new Set();
    return nt(o.current.keys()).forEach(function(I) {
      I.startsWith(p) && $.add(o.current.get(I));
    }), $;
  }, []);
  return l.useEffect(function() {
    return function() {
      S.current = !0;
    };
  }, []), {
    // Register
    registerPath: g,
    unregisterPath: y,
    refreshOverflowKeys: h,
    // Util
    isSubPathKey: b,
    getKeyPath: m,
    getKeys: u,
    getSubPathKeys: C
  };
}
function wt(e) {
  var t = l.useRef(e);
  t.current = e;
  var n = l.useCallback(function() {
    for (var r, o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(a));
  }, []);
  return e ? n : void 0;
}
var gl = Math.random().toFixed(5).toString().slice(2), Er = 0;
function hl(e) {
  var t = kt(e, {
    value: e
  }), n = W(t, 2), r = n[0], o = n[1];
  return l.useEffect(function() {
    Er += 1;
    var a = process.env.NODE_ENV === "test" ? "test" : "".concat(gl, "-").concat(Er);
    o("rc-menu-uuid-".concat(a));
  }, []), r;
}
function xo(e, t) {
  var n = te({}, e);
  return Array.isArray(t) && t.forEach(function(r) {
    delete n[r];
  }), n;
}
function bl(e, t) {
  typeof e == "function" ? e(t) : Nt(e) === "object" && e && "current" in e && (e.current = t);
}
function Cl() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t.filter(function(o) {
    return o;
  });
  return r.length <= 1 ? r[0] : function(o) {
    t.forEach(function(a) {
      bl(a, o);
    });
  };
}
function yl() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Eo(function() {
    return Cl.apply(void 0, t);
  }, t, function(r, o) {
    return r.length !== o.length || r.every(function(a, i) {
      return a !== o[i];
    });
  });
}
function Ro(e, t, n, r) {
  var o = l.useContext(Ae), a = o.activeKey, i = o.onActive, s = o.onInactive, c = {
    active: a === e
  };
  return t || (c.onMouseEnter = function(f) {
    n == null || n({
      key: e,
      domEvent: f
    }), i(e);
  }, c.onMouseLeave = function(f) {
    r == null || r({
      key: e,
      domEvent: f
    }), s(e);
  }), c;
}
function Mo(e) {
  var t = l.useContext(Ae), n = t.mode, r = t.rtl, o = t.inlineIndent;
  if (n !== "inline")
    return null;
  var a = e;
  return r ? {
    paddingRight: a * o
  } : {
    paddingLeft: a * o
  };
}
function Po(e) {
  var t = e.icon, n = e.props, r = e.children, o;
  return t === null || t === !1 ? null : (typeof t == "function" ? o = /* @__PURE__ */ l.createElement(t, te({}, n)) : typeof t != "boolean" && (o = t), o || r || null);
}
var El = ["item"];
function Xt(e) {
  var t = e.item, n = de(e, El);
  return Object.defineProperty(n, "item", {
    get: function() {
      return Be(!1, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future."), t;
    }
  }), n;
}
var Sl = ["title", "attribute", "elementRef"], $l = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"], Il = ["active"], wl = /* @__PURE__ */ function(e) {
  gi(n, e);
  var t = hi(n);
  function n() {
    return bi(this, n), t.apply(this, arguments);
  }
  return Ci(n, [{
    key: "render",
    value: function() {
      var o = this.props, a = o.title, i = o.attribute, s = o.elementRef, c = de(o, Sl), f = xo(c, ["eventKey", "popupClassName", "popupOffset", "onTitleClick"]);
      return Be(!i, "`attribute` of Menu.Item is deprecated. Please pass attribute directly."), /* @__PURE__ */ l.createElement(Ke.Item, Q({}, i, {
        title: typeof a == "string" ? a : void 0
      }, f, {
        ref: s
      }));
    }
  }]), n;
}(l.Component), _l = /* @__PURE__ */ l.forwardRef(function(e, t) {
  var n = e.style, r = e.className, o = e.eventKey, a = e.warnKey, i = e.disabled, s = e.itemIcon, c = e.children, f = e.role, S = e.onMouseEnter, d = e.onMouseLeave, g = e.onClick, y = e.onKeyDown, h = e.onFocus, m = de(e, $l), b = yo(o), u = l.useContext(Ae), C = u.prefixCls, v = u.onItemClick, p = u.disabled, $ = u.overflowDisabled, I = u.itemIcon, E = u.selectedKeys, N = u.onActive, _ = l.useContext(Dn), O = _._internalRenderMenuItem, M = "".concat(C, "-item"), P = l.useRef(), w = l.useRef(), x = p || i, B = yl(t, w), K = vt(o);
  process.env.NODE_ENV !== "production" && a && Be(!1, "MenuItem should not leave undefined `key`.");
  var j = function(le) {
    return {
      key: o,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: nt(K).reverse(),
      item: P.current,
      domEvent: le
    };
  }, V = s || I, k = Ro(o, x, S, d), G = k.active, ne = de(k, Il), L = E.includes(o), X = Mo(K.length), q = function(le) {
    if (!x) {
      var be = j(le);
      g == null || g(Xt(be)), v(be);
    }
  }, Z = function(le) {
    if (y == null || y(le), le.which === R.ENTER) {
      var be = j(le);
      g == null || g(Xt(be)), v(be);
    }
  }, J = function(le) {
    N(o), h == null || h(le);
  }, ae = {};
  e.role === "option" && (ae["aria-selected"] = L);
  var ee = /* @__PURE__ */ l.createElement(wl, Q({
    ref: P,
    elementRef: B,
    role: f === null ? "none" : f || "menuitem",
    tabIndex: i ? null : -1,
    "data-menu-id": $ && b ? null : b
  }, m, ne, ae, {
    component: "li",
    "aria-disabled": i,
    style: te(te({}, X), n),
    className: F(M, oe(oe(oe({}, "".concat(M, "-active"), G), "".concat(M, "-selected"), L), "".concat(M, "-disabled"), x), r),
    onClick: q,
    onKeyDown: Z,
    onFocus: J
  }), c, /* @__PURE__ */ l.createElement(Po, {
    props: te(te({}, e), {}, {
      isSelected: L
    }),
    icon: V
  }));
  return O && (ee = O(ee, e, {
    selected: L
  })), ee;
});
function Nl(e, t) {
  var n = e.eventKey, r = an(), o = vt(n);
  return l.useEffect(function() {
    if (r)
      return r.registerPath(n, o), function() {
        r.unregisterPath(n, o);
      };
  }, [o]), r ? null : /* @__PURE__ */ l.createElement(_l, Q({}, e, {
    ref: t
  }));
}
const sn = /* @__PURE__ */ l.forwardRef(Nl);
var Ol = ["className", "children"], xl = function(t, n) {
  var r = t.className, o = t.children, a = de(t, Ol), i = l.useContext(Ae), s = i.prefixCls, c = i.mode, f = i.rtl;
  return /* @__PURE__ */ l.createElement("ul", Q({
    className: F(s, f && "".concat(s, "-rtl"), "".concat(s, "-sub"), "".concat(s, "-").concat(c === "inline" ? "inline" : "vertical"), r),
    role: "menu"
  }, a, {
    "data-menu-list": !0,
    ref: n
  }), o);
}, jn = /* @__PURE__ */ l.forwardRef(xl);
jn.displayName = "SubMenuList";
function xn(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return ve.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(xn(r)) : Ut.isFragment(r) && r.props ? n = n.concat(xn(r.props.children, t)) : n.push(r));
  }), n;
}
function Un(e, t) {
  return xn(e).map(function(n, r) {
    if (/* @__PURE__ */ l.isValidElement(n)) {
      var o, a, i = n.key, s = (o = (a = n.props) === null || a === void 0 ? void 0 : a.eventKey) !== null && o !== void 0 ? o : i, c = s == null;
      c && (s = "tmp_key-".concat([].concat(nt(t), [r]).join("-")));
      var f = {
        key: s,
        eventKey: s
      };
      return process.env.NODE_ENV !== "production" && c && (f.warnKey = !0), /* @__PURE__ */ l.cloneElement(n, f);
    }
    return n;
  });
}
var ge = {
  adjustX: 1,
  adjustY: 1
}, Rl = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: ge
  },
  topRight: {
    points: ["br", "tr"],
    overflow: ge
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: ge
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: ge
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: ge
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: ge
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: ge
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: ge
  }
}, Ml = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: ge
  },
  topRight: {
    points: ["br", "tr"],
    overflow: ge
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: ge
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: ge
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: ge
  },
  rightBottom: {
    points: ["br", "bl"],
    overflow: ge
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: ge
  },
  leftBottom: {
    points: ["bl", "br"],
    overflow: ge
  }
};
function To(e, t, n) {
  if (t)
    return t;
  if (n)
    return n[e] || n.other;
}
var Pl = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
function Tl(e) {
  var t = e.prefixCls, n = e.visible, r = e.children, o = e.popup, a = e.popupStyle, i = e.popupClassName, s = e.popupOffset, c = e.disabled, f = e.mode, S = e.onVisibleChange, d = l.useContext(Ae), g = d.getPopupContainer, y = d.rtl, h = d.subMenuOpenDelay, m = d.subMenuCloseDelay, b = d.builtinPlacements, u = d.triggerSubMenuAction, C = d.forceSubMenuRender, v = d.rootClassName, p = d.motion, $ = d.defaultMotions, I = l.useState(!1), E = W(I, 2), N = E[0], _ = E[1], O = y ? te(te({}, Ml), b) : te(te({}, Rl), b), M = Pl[f], P = To(f, p, $), w = l.useRef(P);
  f !== "inline" && (w.current = P);
  var x = te(te({}, w.current), {}, {
    leavedClassName: "".concat(t, "-hidden"),
    removeOnLeave: !1,
    motionAppear: !0
  }), B = l.useRef();
  return l.useEffect(function() {
    return B.current = tt(function() {
      _(n);
    }), function() {
      tt.cancel(B.current);
    };
  }, [n]), /* @__PURE__ */ l.createElement(Hr, {
    prefixCls: t,
    popupClassName: F("".concat(t, "-popup"), oe({}, "".concat(t, "-rtl"), y), i, v),
    stretch: f === "horizontal" ? "minWidth" : null,
    getPopupContainer: g,
    builtinPlacements: O,
    popupPlacement: M,
    popupVisible: N,
    popup: o,
    popupStyle: a,
    popupAlign: s && {
      offset: s
    },
    action: c ? [] : [u],
    mouseEnterDelay: h,
    mouseLeaveDelay: m,
    onPopupVisibleChange: S,
    forceRender: C,
    popupMotion: x,
    fresh: !0
  }, r);
}
function Al(e) {
  var t = e.id, n = e.open, r = e.keyPath, o = e.children, a = "inline", i = l.useContext(Ae), s = i.prefixCls, c = i.forceSubMenuRender, f = i.motion, S = i.defaultMotions, d = i.mode, g = l.useRef(!1);
  g.current = d === a;
  var y = l.useState(!g.current), h = W(y, 2), m = h[0], b = h[1], u = g.current ? n : !1;
  l.useEffect(function() {
    g.current && b(!1);
  }, [d]);
  var C = te({}, To(a, f, S));
  r.length > 1 && (C.motionAppear = !1);
  var v = C.onVisibleChanged;
  return C.onVisibleChanged = function(p) {
    return !g.current && !p && b(!0), v == null ? void 0 : v(p);
  }, m ? null : /* @__PURE__ */ l.createElement(Ot, {
    mode: a,
    locked: !g.current
  }, /* @__PURE__ */ l.createElement(wi, Q({
    visible: u
  }, C, {
    forceRender: c,
    removeOnLeave: !1,
    leavedClassName: "".concat(s, "-hidden")
  }), function(p) {
    var $ = p.className, I = p.style;
    return /* @__PURE__ */ l.createElement(jn, {
      id: t,
      className: $,
      style: I
    }, o);
  }));
}
var Bl = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "popupStyle", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"], Dl = ["active"], Ll = /* @__PURE__ */ l.forwardRef(function(e, t) {
  var n = e.style, r = e.className, o = e.title, a = e.eventKey, i = e.warnKey, s = e.disabled, c = e.internalPopupClose, f = e.children, S = e.itemIcon, d = e.expandIcon, g = e.popupClassName, y = e.popupOffset, h = e.popupStyle, m = e.onClick, b = e.onMouseEnter, u = e.onMouseLeave, C = e.onTitleClick, v = e.onTitleMouseEnter, p = e.onTitleMouseLeave, $ = de(e, Bl), I = yo(a), E = l.useContext(Ae), N = E.prefixCls, _ = E.mode, O = E.openKeys, M = E.disabled, P = E.overflowDisabled, w = E.activeKey, x = E.selectedKeys, B = E.itemIcon, K = E.expandIcon, j = E.onItemClick, V = E.onOpenChange, k = E.onActive, G = l.useContext(Dn), ne = G._internalRenderSubMenuItem, L = l.useContext(Io), X = L.isSubPathKey, q = vt(), Z = "".concat(N, "-submenu"), J = M || s, ae = l.useRef(), ee = l.useRef();
  process.env.NODE_ENV !== "production" && i && Be(!1, "SubMenu should not leave undefined `key`.");
  var fe = S ?? B, le = d ?? K, be = O.includes(a), me = !P && be, z = X(x, a), pe = Ro(a, J, v, p), ue = pe.active, je = de(pe, Dl), ht = l.useState(!1), Te = W(ht, 2), Fe = Te[0], Ve = Te[1], We = function(se) {
    J || Ve(se);
  }, bt = function(se) {
    We(!0), b == null || b({
      key: a,
      domEvent: se
    });
  }, Ge = function(se) {
    We(!1), u == null || u({
      key: a,
      domEvent: se
    });
  }, Ue = l.useMemo(function() {
    return ue || (_ !== "inline" ? Fe || X([w], a) : !1);
  }, [_, ue, w, Fe, a, X]), Se = Mo(q.length), $e = function(se) {
    J || (C == null || C({
      key: a,
      domEvent: se
    }), _ === "inline" && V(a, !be));
  }, st = wt(function(Ce) {
    m == null || m(Xt(Ce)), j(Ce);
  }), ct = function(se) {
    _ !== "inline" && V(a, se);
  }, Oe = function() {
    k(a);
  }, De = I && "".concat(I, "-popup"), Ie = /* @__PURE__ */ l.createElement("div", Q({
    role: "menuitem",
    style: Se,
    className: "".concat(Z, "-title"),
    tabIndex: J ? null : -1,
    ref: ae,
    title: typeof o == "string" ? o : null,
    "data-menu-id": P && I ? null : I,
    "aria-expanded": me,
    "aria-haspopup": !0,
    "aria-controls": De,
    "aria-disabled": J,
    onClick: $e,
    onFocus: Oe
  }, je), o, /* @__PURE__ */ l.createElement(Po, {
    icon: _ !== "horizontal" ? le : void 0,
    props: te(te({}, e), {}, {
      isOpen: me,
      // [Legacy] Not sure why need this mark
      isSubMenu: !0
    })
  }, /* @__PURE__ */ l.createElement("i", {
    className: "".concat(Z, "-arrow")
  }))), Le = l.useRef(_);
  if (_ !== "inline" && q.length > 1 ? Le.current = "vertical" : Le.current = _, !P) {
    var xe = Le.current;
    Ie = /* @__PURE__ */ l.createElement(Tl, {
      mode: xe,
      prefixCls: Z,
      visible: !c && me && _ !== "inline",
      popupClassName: g,
      popupOffset: y,
      popupStyle: h,
      popup: /* @__PURE__ */ l.createElement(
        Ot,
        {
          mode: xe === "horizontal" ? "vertical" : xe
        },
        /* @__PURE__ */ l.createElement(jn, {
          id: De,
          ref: ee
        }, f)
      ),
      disabled: J,
      onVisibleChange: ct
    }, Ie);
  }
  var Xe = /* @__PURE__ */ l.createElement(Ke.Item, Q({
    ref: t,
    role: "none"
  }, $, {
    component: "li",
    style: n,
    className: F(Z, "".concat(Z, "-").concat(_), r, oe(oe(oe(oe({}, "".concat(Z, "-open"), me), "".concat(Z, "-active"), Ue), "".concat(Z, "-selected"), z), "".concat(Z, "-disabled"), J)),
    onMouseEnter: bt,
    onMouseLeave: Ge
  }), Ie, !P && /* @__PURE__ */ l.createElement(Al, {
    id: De,
    open: me,
    keyPath: q
  }, f));
  return ne && (Xe = ne(Xe, e, {
    selected: z,
    active: Ue,
    open: me,
    disabled: J
  })), /* @__PURE__ */ l.createElement(Ot, {
    onItemClick: st,
    mode: _ === "horizontal" ? "vertical" : _,
    itemIcon: fe,
    expandIcon: le
  }, Xe);
}), Pt = /* @__PURE__ */ l.forwardRef(function(e, t) {
  var n = e.eventKey, r = e.children, o = vt(n), a = Un(r, o), i = an();
  l.useEffect(function() {
    if (i)
      return i.registerPath(n, o), function() {
        i.unregisterPath(n, o);
      };
  }, [o]);
  var s;
  return i ? s = a : s = /* @__PURE__ */ l.createElement(Ll, Q({
    ref: t
  }, e), a), /* @__PURE__ */ l.createElement($o.Provider, {
    value: o
  }, s);
});
process.env.NODE_ENV !== "production" && (Pt.displayName = "SubMenu");
function kn(e) {
  var t = e.className, n = e.style, r = l.useContext(Ae), o = r.prefixCls, a = an();
  return a ? null : /* @__PURE__ */ l.createElement("li", {
    role: "separator",
    className: F("".concat(o, "-item-divider"), t),
    style: n
  });
}
var Kl = ["className", "title", "eventKey", "children"], jl = /* @__PURE__ */ l.forwardRef(function(e, t) {
  var n = e.className, r = e.title;
  e.eventKey;
  var o = e.children, a = de(e, Kl), i = l.useContext(Ae), s = i.prefixCls, c = "".concat(s, "-item-group");
  return /* @__PURE__ */ l.createElement("li", Q({
    ref: t,
    role: "presentation"
  }, a, {
    onClick: function(S) {
      return S.stopPropagation();
    },
    className: F(c, n)
  }), /* @__PURE__ */ l.createElement("div", {
    role: "presentation",
    className: "".concat(c, "-title"),
    title: typeof r == "string" ? r : void 0
  }, r), /* @__PURE__ */ l.createElement("ul", {
    role: "group",
    className: "".concat(c, "-list")
  }, o));
}), cn = /* @__PURE__ */ l.forwardRef(function(e, t) {
  var n = e.eventKey, r = e.children, o = vt(n), a = Un(r, o), i = an();
  return i ? a : /* @__PURE__ */ l.createElement(jl, Q({
    ref: t
  }, xo(e, ["warnKey"])), a);
});
process.env.NODE_ENV !== "production" && (cn.displayName = "MenuItemGroup");
var Ul = ["label", "children", "key", "type"];
function Rn(e, t) {
  var n = t.item, r = t.group, o = t.submenu, a = t.divider;
  return (e || []).map(function(i, s) {
    if (i && Nt(i) === "object") {
      var c = i, f = c.label, S = c.children, d = c.key, g = c.type, y = de(c, Ul), h = d ?? "tmp-".concat(s);
      return S || g === "group" ? g === "group" ? /* @__PURE__ */ l.createElement(r, Q({
        key: h
      }, y, {
        title: f
      }), Rn(S, t)) : /* @__PURE__ */ l.createElement(o, Q({
        key: h
      }, y, {
        title: f
      }), Rn(S, t)) : g === "divider" ? /* @__PURE__ */ l.createElement(a, Q({
        key: h
      }, y)) : /* @__PURE__ */ l.createElement(n, Q({
        key: h
      }, y), f);
    }
    return null;
  }).filter(function(i) {
    return i;
  });
}
function Sr(e, t, n, r) {
  var o = e, a = te({
    divider: kn,
    item: sn,
    group: cn,
    submenu: Pt
  }, r);
  return t && (o = Rn(t, a)), Un(o, n);
}
var kl = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem", "_internalComponents"], Je = [], zl = /* @__PURE__ */ l.forwardRef(function(e, t) {
  var n, r = e, o = r.prefixCls, a = o === void 0 ? "rc-menu" : o, i = r.rootClassName, s = r.style, c = r.className, f = r.tabIndex, S = f === void 0 ? 0 : f, d = r.items, g = r.children, y = r.direction, h = r.id, m = r.mode, b = m === void 0 ? "vertical" : m, u = r.inlineCollapsed, C = r.disabled, v = r.disabledOverflow, p = r.subMenuOpenDelay, $ = p === void 0 ? 0.1 : p, I = r.subMenuCloseDelay, E = I === void 0 ? 0.1 : I, N = r.forceSubMenuRender, _ = r.defaultOpenKeys, O = r.openKeys, M = r.activeKey, P = r.defaultActiveFirst, w = r.selectable, x = w === void 0 ? !0 : w, B = r.multiple, K = B === void 0 ? !1 : B, j = r.defaultSelectedKeys, V = r.selectedKeys, k = r.onSelect, G = r.onDeselect, ne = r.inlineIndent, L = ne === void 0 ? 24 : ne, X = r.motion, q = r.defaultMotions, Z = r.triggerSubMenuAction, J = Z === void 0 ? "hover" : Z, ae = r.builtinPlacements, ee = r.itemIcon, fe = r.expandIcon, le = r.overflowedIndicator, be = le === void 0 ? "..." : le, me = r.overflowedIndicatorPopupClassName, z = r.getPopupContainer, pe = r.onClick, ue = r.onOpenChange, je = r.onKeyDown, ht = r.openAnimation, Te = r.openTransitionName, Fe = r._internalRenderMenuItem, Ve = r._internalRenderSubMenuItem, We = r._internalComponents, bt = de(r, kl), Ge = l.useMemo(function() {
    return [Sr(g, d, Je, We), Sr(g, d, Je, {})];
  }, [g, d, We]), Ue = W(Ge, 2), Se = Ue[0], $e = Ue[1], st = l.useState(!1), ct = W(st, 2), Oe = ct[0], De = ct[1], Ie = l.useRef(), Le = hl(h), xe = y === "rtl";
  process.env.NODE_ENV !== "production" && Be(!ht && !Te, "`openAnimation` and `openTransitionName` is removed. Please use `motion` or `defaultMotion` instead.");
  var Xe = kt(_, {
    value: O,
    postState: function(Y) {
      return Y || Je;
    }
  }), Ce = W(Xe, 2), se = Ce[0], At = Ce[1], Ye = function(Y) {
    var re = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    function _e() {
      At(Y), ue == null || ue(Y);
    }
    re ? Mn.flushSync(_e) : _e();
  }, Bt = l.useState(se), Ct = W(Bt, 2), qe = Ct[0], dn = Ct[1], Qe = l.useRef(!1), Dt = l.useMemo(function() {
    return (b === "inline" || b === "vertical") && u ? ["vertical", u] : [b, !1];
  }, [b, u]), ut = W(Dt, 2), ke = ut[0], D = ut[1], H = ke === "inline", ce = l.useState(ke), we = W(ce, 2), ye = we[0], Vo = we[1], Wo = l.useState(D), Fn = W(Wo, 2), Go = Fn[0], Xo = Fn[1];
  l.useEffect(function() {
    Vo(ke), Xo(D), Qe.current && (H ? At(qe) : Ye(Je));
  }, [ke, D]);
  var Yo = l.useState(0), Vn = W(Yo, 2), Lt = Vn[0], qo = Vn[1], fn = Lt >= Se.length - 1 || ye !== "horizontal" || v;
  l.useEffect(function() {
    H && dn(se);
  }, [se]), l.useEffect(function() {
    return Qe.current = !0, function() {
      Qe.current = !1;
    };
  }, []);
  var Ze = vl(), Wn = Ze.registerPath, Gn = Ze.unregisterPath, Qo = Ze.refreshOverflowKeys, Xn = Ze.isSubPathKey, Zo = Ze.getKeyPath, Yn = Ze.getKeys, Jo = Ze.getSubPathKeys, ei = l.useMemo(function() {
    return {
      registerPath: Wn,
      unregisterPath: Gn
    };
  }, [Wn, Gn]), ti = l.useMemo(function() {
    return {
      isSubPathKey: Xn
    };
  }, [Xn]);
  l.useEffect(function() {
    Qo(fn ? Je : Se.slice(Lt + 1).map(function(ie) {
      return ie.key;
    }));
  }, [Lt, fn]);
  var ni = kt(M || P && ((n = Se[0]) === null || n === void 0 ? void 0 : n.key), {
    value: M
  }), qn = W(ni, 2), yt = qn[0], mn = qn[1], ri = wt(function(ie) {
    mn(ie);
  }), oi = wt(function() {
    mn(void 0);
  });
  Br(t, function() {
    return {
      list: Ie.current,
      focus: function(Y) {
        var re, _e = Yn(), Ne = Nn(_e, Le), jt = Ne.elements, pn = Ne.key2element, pi = Ne.element2key, Jn = Ln(Ie.current, jt), er = yt ?? (Jn[0] ? pi.get(Jn[0]) : (re = Se.find(function(vi) {
          return !vi.props.disabled;
        })) === null || re === void 0 ? void 0 : re.key), Et = pn.get(er);
        if (er && Et) {
          var vn;
          Et == null || (vn = Et.focus) === null || vn === void 0 || vn.call(Et, Y);
        }
      }
    };
  });
  var ii = kt(j || [], {
    value: V,
    // Legacy convert key to array
    postState: function(Y) {
      return Array.isArray(Y) ? Y : Y == null ? Je : [Y];
    }
  }), Qn = W(ii, 2), Kt = Qn[0], ai = Qn[1], li = function(Y) {
    if (x) {
      var re = Y.key, _e = Kt.includes(re), Ne;
      K ? _e ? Ne = Kt.filter(function(pn) {
        return pn !== re;
      }) : Ne = [].concat(nt(Kt), [re]) : Ne = [re], ai(Ne);
      var jt = te(te({}, Y), {}, {
        selectedKeys: Ne
      });
      _e ? G == null || G(jt) : k == null || k(jt);
    }
    !K && se.length && ye !== "inline" && Ye(Je);
  }, si = wt(function(ie) {
    pe == null || pe(Xt(ie)), li(ie);
  }), Zn = wt(function(ie, Y) {
    var re = se.filter(function(Ne) {
      return Ne !== ie;
    });
    if (Y)
      re.push(ie);
    else if (ye !== "inline") {
      var _e = Jo(ie);
      re = re.filter(function(Ne) {
        return !_e.has(Ne);
      });
    }
    ho(se, re, !0) || Ye(re, !0);
  }), ci = function(Y, re) {
    var _e = re ?? !se.includes(Y);
    Zn(Y, _e);
  }, ui = fl(ye, yt, xe, Le, Ie, Yn, Zo, mn, ci, je);
  l.useEffect(function() {
    De(!0);
  }, []);
  var di = l.useMemo(function() {
    return {
      _internalRenderMenuItem: Fe,
      _internalRenderSubMenuItem: Ve
    };
  }, [Fe, Ve]), fi = ye !== "horizontal" || v ? Se : (
    // Need wrap for overflow dropdown that do not response for open
    Se.map(function(ie, Y) {
      return (
        // Always wrap provider to avoid sub node re-mount
        /* @__PURE__ */ l.createElement(Ot, {
          key: ie.key,
          overflowDisabled: Y > Lt
        }, ie)
      );
    })
  ), mi = /* @__PURE__ */ l.createElement(Ke, Q({
    id: h,
    ref: Ie,
    prefixCls: "".concat(a, "-overflow"),
    component: "ul",
    itemComponent: sn,
    className: F(a, "".concat(a, "-root"), "".concat(a, "-").concat(ye), c, oe(oe({}, "".concat(a, "-inline-collapsed"), Go), "".concat(a, "-rtl"), xe), i),
    dir: y,
    style: s,
    role: "menu",
    tabIndex: S,
    data: fi,
    renderRawItem: function(Y) {
      return Y;
    },
    renderRawRest: function(Y) {
      var re = Y.length, _e = re ? Se.slice(-re) : null;
      return /* @__PURE__ */ l.createElement(Pt, {
        eventKey: On,
        title: be,
        disabled: fn,
        internalPopupClose: re === 0,
        popupClassName: me
      }, _e);
    },
    maxCount: ye !== "horizontal" || v ? Ke.INVALIDATE : Ke.RESPONSIVE,
    ssr: "full",
    "data-menu-list": !0,
    onVisibleChange: function(Y) {
      qo(Y);
    },
    onKeyDown: ui
  }, bt));
  return /* @__PURE__ */ l.createElement(Dn.Provider, {
    value: di
  }, /* @__PURE__ */ l.createElement(bo.Provider, {
    value: Le
  }, /* @__PURE__ */ l.createElement(Ot, {
    prefixCls: a,
    rootClassName: i,
    mode: ye,
    openKeys: se,
    rtl: xe,
    disabled: C,
    motion: Oe ? X : null,
    defaultMotions: Oe ? q : null,
    activeKey: yt,
    onActive: ri,
    onInactive: oi,
    selectedKeys: Kt,
    inlineIndent: L,
    subMenuOpenDelay: $,
    subMenuCloseDelay: E,
    forceSubMenuRender: N,
    builtinPlacements: ae,
    triggerSubMenuAction: J,
    getPopupContainer: z,
    itemIcon: ee,
    expandIcon: fe,
    onItemClick: si,
    onOpenChange: Zn
  }, /* @__PURE__ */ l.createElement(Io.Provider, {
    value: ti
  }, mi), /* @__PURE__ */ l.createElement("div", {
    style: {
      display: "none"
    },
    "aria-hidden": !0
  }, /* @__PURE__ */ l.createElement(So.Provider, {
    value: ei
  }, $e)))));
}), Tt = zl;
Tt.Item = sn;
Tt.SubMenu = Pt;
Tt.ItemGroup = cn;
Tt.Divider = kn;
var Hl = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "bars", theme: "outlined" };
const Fl = Hl;
var Vl = function(t, n) {
  return /* @__PURE__ */ l.createElement(Qt, Q({}, t, {
    ref: n,
    icon: Fl
  }));
}, Ao = /* @__PURE__ */ l.forwardRef(Vl);
process.env.NODE_ENV !== "production" && (Ao.displayName = "BarsOutlined");
const Wl = Ao;
var Gl = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" };
const Xl = Gl;
var Yl = function(t, n) {
  return /* @__PURE__ */ l.createElement(Qt, Q({}, t, {
    ref: n,
    icon: Xl
  }));
}, Bo = /* @__PURE__ */ l.forwardRef(Yl);
process.env.NODE_ENV !== "production" && (Bo.displayName = "LeftOutlined");
const $r = Bo, ql = (e) => !isNaN(parseFloat(e)) && isFinite(e), Ql = ql, Zl = /* @__PURE__ */ l.createContext({
  siderHook: {
    addSider: () => null,
    removeSider: () => null
  }
});
var Jl = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Ir = {
  xs: "479.98px",
  sm: "575.98px",
  md: "767.98px",
  lg: "991.98px",
  xl: "1199.98px",
  xxl: "1599.98px"
}, zn = /* @__PURE__ */ l.createContext({}), es = (() => {
  let e = 0;
  return function() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return e += 1, `${t}${e}`;
  };
})(), ts = /* @__PURE__ */ l.forwardRef((e, t) => {
  const {
    prefixCls: n,
    className: r,
    trigger: o,
    children: a,
    defaultCollapsed: i = !1,
    theme: s = "dark",
    style: c = {},
    collapsible: f = !1,
    reverseArrow: S = !1,
    width: d = 200,
    collapsedWidth: g = 80,
    zeroWidthTriggerStyle: y,
    breakpoint: h,
    onCollapse: m,
    onBreakpoint: b
  } = e, u = Jl(e, ["prefixCls", "className", "trigger", "children", "defaultCollapsed", "theme", "style", "collapsible", "reverseArrow", "width", "collapsedWidth", "zeroWidthTriggerStyle", "breakpoint", "onCollapse", "onBreakpoint"]), {
    siderHook: C
  } = nr(Zl), [v, p] = Me("collapsed" in e ? e.collapsed : i), [$, I] = Me(!1);
  Pe(() => {
    "collapsed" in e && p(e.collapsed);
  }, [e.collapsed]);
  const E = (w, x) => {
    "collapsed" in e || p(w), m == null || m(w, x);
  }, N = pt();
  N.current = (w) => {
    I(w.matches), b == null || b(w.matches), v !== w.matches && E(w.matches, "responsive");
  }, Pe(() => {
    function w(B) {
      return N.current(B);
    }
    let x;
    if (typeof window < "u") {
      const {
        matchMedia: B
      } = window;
      if (B && h && h in Ir) {
        x = B(`screen and (max-width: ${Ir[h]})`);
        try {
          x.addEventListener("change", w);
        } catch {
          x.addListener(w);
        }
        w(x);
      }
    }
    return () => {
      try {
        x == null || x.removeEventListener("change", w);
      } catch {
        x == null || x.removeListener(w);
      }
    };
  }, [h]), Pe(() => {
    const w = es("ant-sider-");
    return C.addSider(w), () => C.removeSider(w);
  }, []);
  const _ = () => {
    E(!v, "clickTrigger");
  }, {
    getPrefixCls: O
  } = nr(it), M = () => {
    const w = O("layout-sider", n), x = Rt(u, ["collapsed"]), B = v ? g : d, K = Ql(B) ? `${B}px` : String(B), j = parseFloat(String(g || 0)) === 0 ? /* @__PURE__ */ l.createElement("span", {
      onClick: _,
      className: F(`${w}-zero-width-trigger`, `${w}-zero-width-trigger-${S ? "right" : "left"}`),
      style: y
    }, o || /* @__PURE__ */ l.createElement(Wl, null)) : null, G = {
      expanded: S ? /* @__PURE__ */ l.createElement(Sn, null) : /* @__PURE__ */ l.createElement($r, null),
      collapsed: S ? /* @__PURE__ */ l.createElement($r, null) : /* @__PURE__ */ l.createElement(Sn, null)
    }[v ? "collapsed" : "expanded"], ne = o !== null ? j || /* @__PURE__ */ l.createElement("div", {
      className: `${w}-trigger`,
      onClick: _,
      style: {
        width: K
      }
    }, o || G) : null, L = Object.assign(Object.assign({}, c), {
      flex: `0 0 ${K}`,
      maxWidth: K,
      minWidth: K,
      width: K
    }), X = F(w, `${w}-${s}`, {
      [`${w}-collapsed`]: !!v,
      [`${w}-has-trigger`]: f && o !== null && !j,
      [`${w}-below`]: !!$,
      [`${w}-zero-width`]: parseFloat(K) === 0
    }, r);
    return /* @__PURE__ */ l.createElement("aside", Object.assign({
      className: X
    }, x, {
      style: L,
      ref: t
    }), /* @__PURE__ */ l.createElement("div", {
      className: `${w}-children`
    }, a), f || $ && j ? ne : null);
  }, P = l.useMemo(() => ({
    siderCollapsed: v
  }), [v]);
  return /* @__PURE__ */ l.createElement(zn.Provider, {
    value: P
  }, M());
});
process.env.NODE_ENV !== "production" && (ts.displayName = "Sider");
var ns = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" };
const rs = ns;
var os = function(t, n) {
  return /* @__PURE__ */ l.createElement(Qt, Q({}, t, {
    ref: n,
    icon: rs
  }));
}, Do = /* @__PURE__ */ l.forwardRef(os);
process.env.NODE_ENV !== "production" && (Do.displayName = "EllipsisOutlined");
const Lo = Do;
var is = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const as = (e) => {
  const {
    prefixCls: t,
    className: n,
    dashed: r
  } = e, o = is(e, ["prefixCls", "className", "dashed"]), {
    getPrefixCls: a
  } = l.useContext(it), i = a("menu", t), s = F({
    [`${i}-item-divider-dashed`]: !!r
  }, n);
  return /* @__PURE__ */ l.createElement(kn, Object.assign({
    className: s
  }, o));
}, Ko = as, ls = /* @__PURE__ */ $i({
  prefixCls: "",
  firstLevel: !0,
  inlineCollapsed: !1
}), Yt = ls, ss = (e) => {
  var t;
  const {
    className: n,
    children: r,
    icon: o,
    title: a,
    danger: i
  } = e, {
    prefixCls: s,
    firstLevel: c,
    direction: f,
    disableMenuItemTitleTooltip: S,
    inlineCollapsed: d
  } = l.useContext(Yt), g = (C) => {
    const v = /* @__PURE__ */ l.createElement("span", {
      className: `${s}-title-content`
    }, r);
    return (!o || /* @__PURE__ */ l.isValidElement(r) && r.type === "span") && r && C && c && typeof r == "string" ? /* @__PURE__ */ l.createElement("div", {
      className: `${s}-inline-collapsed-noicon`
    }, r.charAt(0)) : v;
  }, {
    siderCollapsed: y
  } = l.useContext(zn);
  let h = a;
  typeof a > "u" ? h = c ? r : "" : a === !1 && (h = "");
  const m = {
    title: h
  };
  !y && !d && (m.title = null, m.open = !1);
  const b = Fr(r).length;
  let u = /* @__PURE__ */ l.createElement(sn, Object.assign({}, Rt(e, ["title", "icon", "danger"]), {
    className: F({
      [`${s}-item-danger`]: i,
      [`${s}-item-only-child`]: (o ? b + 1 : b) === 1
    }, n),
    title: typeof a == "string" ? a : void 0
  }), Zt(o, {
    className: F(/* @__PURE__ */ l.isValidElement(o) ? (t = o.props) === null || t === void 0 ? void 0 : t.className : "", `${s}-item-icon`)
  }), g(d));
  return S || (u = /* @__PURE__ */ l.createElement(Vr, Object.assign({}, m, {
    placement: f === "rtl" ? "left" : "right",
    overlayClassName: `${s}-inline-collapsed-tooltip`
  }), u)), u;
}, jo = ss;
var cs = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const qt = /* @__PURE__ */ l.createContext(null), us = /* @__PURE__ */ l.forwardRef((e, t) => {
  const {
    children: n
  } = e, r = cs(e, ["children"]), o = l.useContext(qt), a = l.useMemo(() => Object.assign(Object.assign({}, o), r), [
    o,
    r.prefixCls,
    // restProps.expandIcon, Not mark as deps since this is a ReactNode
    r.mode,
    r.selectable,
    r.rootClassName
    // restProps.validator, Not mark as deps since this is a function
  ]), i = yi(n), s = Ei(t, i ? n.ref : null);
  return /* @__PURE__ */ l.createElement(qt.Provider, {
    value: a
  }, /* @__PURE__ */ l.createElement(Ti, null, i ? /* @__PURE__ */ l.cloneElement(n, {
    ref: s
  }) : n));
}), ds = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    horizontalLineHeight: r,
    colorSplit: o,
    lineWidth: a,
    lineType: i,
    itemPaddingInline: s
  } = e;
  return {
    [`${t}-horizontal`]: {
      lineHeight: r,
      border: 0,
      borderBottom: `${U(a)} ${i} ${o}`,
      boxShadow: "none",
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        content: '"\\20"'
      },
      // ======================= Item =======================
      [`${t}-item, ${t}-submenu`]: {
        position: "relative",
        display: "inline-block",
        verticalAlign: "bottom",
        paddingInline: s
      },
      [`> ${t}-item:hover,
        > ${t}-item-active,
        > ${t}-submenu ${t}-submenu-title:hover`]: {
        backgroundColor: "transparent"
      },
      [`${t}-item, ${t}-submenu-title`]: {
        transition: [`border-color ${n}`, `background ${n}`].join(",")
      },
      // ===================== Sub Menu =====================
      [`${t}-submenu-arrow`]: {
        display: "none"
      }
    }
  };
}, fs = ds, ms = (e) => {
  let {
    componentCls: t,
    menuArrowOffset: n,
    calc: r
  } = e;
  return {
    [`${t}-rtl`]: {
      direction: "rtl"
    },
    [`${t}-submenu-rtl`]: {
      transformOrigin: "100% 0"
    },
    // Vertical Arrow
    [`${t}-rtl${t}-vertical,
    ${t}-submenu-rtl ${t}-vertical`]: {
      [`${t}-submenu-arrow`]: {
        "&::before": {
          transform: `rotate(-45deg) translateY(${U(r(n).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(45deg) translateY(${U(n)})`
        }
      }
    }
  };
}, ps = ms, wr = (e) => Object.assign({}, _i(e)), vs = (e, t) => {
  const {
    componentCls: n,
    itemColor: r,
    itemSelectedColor: o,
    groupTitleColor: a,
    itemBg: i,
    subMenuItemBg: s,
    itemSelectedBg: c,
    activeBarHeight: f,
    activeBarWidth: S,
    activeBarBorderWidth: d,
    motionDurationSlow: g,
    motionEaseInOut: y,
    motionEaseOut: h,
    itemPaddingInline: m,
    motionDurationMid: b,
    itemHoverColor: u,
    lineType: C,
    colorSplit: v,
    // Disabled
    itemDisabledColor: p,
    // Danger
    dangerItemColor: $,
    dangerItemHoverColor: I,
    dangerItemSelectedColor: E,
    dangerItemActiveBg: N,
    dangerItemSelectedBg: _,
    // Bg
    popupBg: O,
    itemHoverBg: M,
    itemActiveBg: P,
    menuSubMenuBg: w,
    // Horizontal
    horizontalItemSelectedColor: x,
    horizontalItemSelectedBg: B,
    horizontalItemBorderRadius: K,
    horizontalItemHoverBg: j
  } = e;
  return {
    [`${n}-${t}, ${n}-${t} > ${n}`]: {
      color: r,
      background: i,
      [`&${n}-root:focus-visible`]: Object.assign({}, wr(e)),
      // ======================== Item ========================
      [`${n}-item-group-title`]: {
        color: a
      },
      [`${n}-submenu-selected`]: {
        [`> ${n}-submenu-title`]: {
          color: o
        }
      },
      [`${n}-item, ${n}-submenu-title`]: {
        color: r,
        [`&:not(${n}-item-disabled):focus-visible`]: Object.assign({}, wr(e))
      },
      // Disabled
      [`${n}-item-disabled, ${n}-submenu-disabled`]: {
        color: `${p} !important`
      },
      // Hover
      [`${n}-item:not(${n}-item-selected):not(${n}-submenu-selected)`]: {
        [`&:hover, > ${n}-submenu-title:hover`]: {
          color: u
        }
      },
      [`&:not(${n}-horizontal)`]: {
        [`${n}-item:not(${n}-item-selected)`]: {
          "&:hover": {
            backgroundColor: M
          },
          "&:active": {
            backgroundColor: P
          }
        },
        [`${n}-submenu-title`]: {
          "&:hover": {
            backgroundColor: M
          },
          "&:active": {
            backgroundColor: P
          }
        }
      },
      // Danger - only Item has
      [`${n}-item-danger`]: {
        color: $,
        [`&${n}-item:hover`]: {
          [`&:not(${n}-item-selected):not(${n}-submenu-selected)`]: {
            color: I
          }
        },
        [`&${n}-item:active`]: {
          background: N
        }
      },
      [`${n}-item a`]: {
        "&, &:hover": {
          color: "inherit"
        }
      },
      [`${n}-item-selected`]: {
        color: o,
        // Danger
        [`&${n}-item-danger`]: {
          color: E
        },
        "a, a:hover": {
          color: "inherit"
        }
      },
      [`& ${n}-item-selected`]: {
        backgroundColor: c,
        // Danger
        [`&${n}-item-danger`]: {
          backgroundColor: _
        }
      },
      [`&${n}-submenu > ${n}`]: {
        backgroundColor: w
      },
      // ===== 设置浮层的颜色 =======
      // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
      [`&${n}-popup > ${n}`]: {
        backgroundColor: O
      },
      [`&${n}-submenu-popup > ${n}`]: {
        backgroundColor: O
      },
      // ===== 设置浮层的颜色 end =======
      // ====================== Horizontal ======================
      [`&${n}-horizontal`]: Object.assign(Object.assign({}, t === "dark" ? {
        borderBottom: 0
      } : {}), {
        [`> ${n}-item, > ${n}-submenu`]: {
          top: d,
          marginTop: e.calc(d).mul(-1).equal(),
          marginBottom: 0,
          borderRadius: K,
          "&::after": {
            position: "absolute",
            insetInline: m,
            bottom: 0,
            borderBottom: `${U(f)} solid transparent`,
            transition: `border-color ${g} ${y}`,
            content: '""'
          },
          "&:hover, &-active, &-open": {
            background: j,
            "&::after": {
              borderBottomWidth: f,
              borderBottomColor: x
            }
          },
          "&-selected": {
            color: x,
            backgroundColor: B,
            "&:hover": {
              backgroundColor: B
            },
            "&::after": {
              borderBottomWidth: f,
              borderBottomColor: x
            }
          }
        }
      }),
      // ================== Inline & Vertical ===================
      //
      [`&${n}-root`]: {
        [`&${n}-inline, &${n}-vertical`]: {
          borderInlineEnd: `${U(d)} ${C} ${v}`
        }
      },
      // ======================== Inline ========================
      [`&${n}-inline`]: {
        // Sub
        [`${n}-sub${n}-inline`]: {
          background: s
        },
        [`${n}-item`]: {
          position: "relative",
          "&::after": {
            position: "absolute",
            insetBlock: 0,
            insetInlineEnd: 0,
            borderInlineEnd: `${U(S)} solid ${o}`,
            transform: "scaleY(0.0001)",
            opacity: 0,
            transition: [`transform ${b} ${h}`, `opacity ${b} ${h}`].join(","),
            content: '""'
          },
          // Danger
          [`&${n}-item-danger`]: {
            "&::after": {
              borderInlineEndColor: E
            }
          }
        },
        [`${n}-selected, ${n}-item-selected`]: {
          "&::after": {
            transform: "scaleY(1)",
            opacity: 1,
            transition: [`transform ${b} ${y}`, `opacity ${b} ${y}`].join(",")
          }
        }
      }
    }
  };
}, _r = vs, Nr = (e) => {
  const {
    componentCls: t,
    itemHeight: n,
    itemMarginInline: r,
    padding: o,
    menuArrowSize: a,
    marginXS: i,
    itemMarginBlock: s,
    itemWidth: c
  } = e, f = e.calc(a).add(o).add(i).equal();
  return {
    [`${t}-item`]: {
      position: "relative",
      overflow: "hidden"
    },
    [`${t}-item, ${t}-submenu-title`]: {
      height: n,
      lineHeight: U(n),
      paddingInline: o,
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginInline: r,
      marginBlock: s,
      width: c
    },
    [`> ${t}-item,
            > ${t}-submenu > ${t}-submenu-title`]: {
      height: n,
      lineHeight: U(n)
    },
    [`${t}-item-group-list ${t}-submenu-title,
            ${t}-submenu-title`]: {
      paddingInlineEnd: f
    }
  };
}, gs = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    itemHeight: r,
    colorTextLightSolid: o,
    dropdownWidth: a,
    controlHeightLG: i,
    motionDurationMid: s,
    motionEaseOut: c,
    paddingXL: f,
    itemMarginInline: S,
    fontSizeLG: d,
    motionDurationSlow: g,
    paddingXS: y,
    boxShadowSecondary: h,
    collapsedWidth: m,
    collapsedIconSize: b
  } = e, u = {
    height: r,
    lineHeight: U(r),
    listStylePosition: "inside",
    listStyleType: "disc"
  };
  return [
    {
      [t]: {
        "&-inline, &-vertical": Object.assign({
          [`&${t}-root`]: {
            boxShadow: "none"
          }
        }, Nr(e))
      },
      [`${t}-submenu-popup`]: {
        [`${t}-vertical`]: Object.assign(Object.assign({}, Nr(e)), {
          boxShadow: h
        })
      }
    },
    // Vertical only
    {
      [`${t}-submenu-popup ${t}-vertical${t}-sub`]: {
        minWidth: a,
        maxHeight: `calc(100vh - ${U(e.calc(i).mul(2.5).equal())})`,
        padding: "0",
        overflow: "hidden",
        borderInlineEnd: 0,
        // https://github.com/ant-design/ant-design/issues/22244
        // https://github.com/ant-design/ant-design/issues/26812
        "&:not([class*='-active'])": {
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    },
    // Inline Only
    {
      [`${t}-inline`]: {
        width: "100%",
        // Motion enhance for first level
        [`&${t}-root`]: {
          [`${t}-item, ${t}-submenu-title`]: {
            display: "flex",
            alignItems: "center",
            transition: [`border-color ${g}`, `background ${g}`, `padding ${s} ${c}`, `padding-inline calc(50% - ${U(e.calc(d).div(2).equal())} - ${U(S)})`].join(","),
            [`> ${t}-title-content`]: {
              flex: "auto",
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            "> *": {
              flex: "none"
            }
          }
        },
        // >>>>> Sub
        [`${t}-sub${t}-inline`]: {
          padding: 0,
          border: 0,
          borderRadius: 0,
          boxShadow: "none",
          [`& > ${t}-submenu > ${t}-submenu-title`]: u,
          [`& ${t}-item-group-title`]: {
            paddingInlineStart: f
          }
        },
        // >>>>> Item
        [`${t}-item`]: u
      }
    },
    // Inline Collapse Only
    {
      [`${t}-inline-collapsed`]: {
        width: m,
        [`&${t}-root`]: {
          [`${t}-item, ${t}-submenu ${t}-submenu-title`]: {
            [`> ${t}-inline-collapsed-noicon`]: {
              fontSize: d,
              textAlign: "center"
            }
          }
        },
        [`> ${t}-item,
          > ${t}-item-group > ${t}-item-group-list > ${t}-item,
          > ${t}-item-group > ${t}-item-group-list > ${t}-submenu > ${t}-submenu-title,
          > ${t}-submenu > ${t}-submenu-title`]: {
          insetInlineStart: 0,
          paddingInline: `calc(50% - ${U(e.calc(d).div(2).equal())} - ${U(S)})`,
          textOverflow: "clip",
          [`
            ${t}-submenu-arrow,
            ${t}-submenu-expand-icon
          `]: {
            opacity: 0
          },
          [`${t}-item-icon, ${n}`]: {
            margin: 0,
            fontSize: b,
            lineHeight: U(r),
            "+ span": {
              display: "inline-block",
              opacity: 0
            }
          }
        },
        [`${t}-item-icon, ${n}`]: {
          display: "inline-block"
        },
        "&-tooltip": {
          pointerEvents: "none",
          [`${t}-item-icon, ${n}`]: {
            display: "none"
          },
          "a, a:hover": {
            color: o
          }
        },
        [`${t}-item-group-title`]: Object.assign(Object.assign({}, Ni), {
          paddingInline: y
        })
      }
    }
  ];
}, hs = gs, Or = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    motionDurationMid: r,
    motionEaseInOut: o,
    motionEaseOut: a,
    iconCls: i,
    iconSize: s,
    iconMarginInlineEnd: c
  } = e;
  return {
    // >>>>> Item
    [`${t}-item, ${t}-submenu-title`]: {
      position: "relative",
      display: "block",
      margin: 0,
      whiteSpace: "nowrap",
      cursor: "pointer",
      transition: [`border-color ${n}`, `background ${n}`, `padding ${n} ${o}`].join(","),
      [`${t}-item-icon, ${i}`]: {
        minWidth: s,
        fontSize: s,
        transition: [`font-size ${r} ${a}`, `margin ${n} ${o}`, `color ${n}`].join(","),
        "+ span": {
          marginInlineStart: c,
          opacity: 1,
          transition: [`opacity ${n} ${o}`, `margin ${n}`, `color ${n}`].join(",")
        }
      },
      [`${t}-item-icon`]: Object.assign({}, Oi()),
      [`&${t}-item-only-child`]: {
        [`> ${i}, > ${t}-item-icon`]: {
          marginInlineEnd: 0
        }
      }
    },
    // Disabled state sets text to gray and nukes hover/tab effects
    [`${t}-item-disabled, ${t}-submenu-disabled`]: {
      background: "none !important",
      cursor: "not-allowed",
      "&::after": {
        borderColor: "transparent !important"
      },
      a: {
        color: "inherit !important"
      },
      [`> ${t}-submenu-title`]: {
        color: "inherit !important",
        cursor: "not-allowed"
      }
    }
  };
}, xr = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    motionEaseInOut: r,
    borderRadius: o,
    menuArrowSize: a,
    menuArrowOffset: i
  } = e;
  return {
    [`${t}-submenu`]: {
      "&-expand-icon, &-arrow": {
        position: "absolute",
        top: "50%",
        insetInlineEnd: e.margin,
        width: a,
        color: "currentcolor",
        transform: "translateY(-50%)",
        transition: `transform ${n} ${r}, opacity ${n}`
      },
      "&-arrow": {
        // →
        "&::before, &::after": {
          position: "absolute",
          width: e.calc(a).mul(0.6).equal(),
          height: e.calc(a).mul(0.15).equal(),
          backgroundColor: "currentcolor",
          borderRadius: o,
          transition: [`background ${n} ${r}`, `transform ${n} ${r}`, `top ${n} ${r}`, `color ${n} ${r}`].join(","),
          content: '""'
        },
        "&::before": {
          transform: `rotate(45deg) translateY(${U(e.calc(i).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(-45deg) translateY(${U(i)})`
        }
      }
    }
  };
}, bs = (e) => {
  const {
    antCls: t,
    componentCls: n,
    fontSize: r,
    motionDurationSlow: o,
    motionDurationMid: a,
    motionEaseInOut: i,
    paddingXS: s,
    padding: c,
    colorSplit: f,
    lineWidth: S,
    zIndexPopup: d,
    borderRadiusLG: g,
    subMenuItemBorderRadius: y,
    menuArrowSize: h,
    menuArrowOffset: m,
    lineType: b,
    groupTitleLineHeight: u,
    groupTitleFontSize: C
  } = e;
  return [
    // Misc
    {
      "": {
        [`${n}`]: Object.assign(Object.assign({}, rr()), {
          // Hidden
          "&-hidden": {
            display: "none"
          }
        })
      },
      [`${n}-submenu-hidden`]: {
        display: "none"
      }
    },
    {
      [n]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Lr(e)), rr()), {
        marginBottom: 0,
        paddingInlineStart: 0,
        // Override default ul/ol
        fontSize: r,
        lineHeight: 0,
        listStyle: "none",
        outline: "none",
        // Magic cubic here but smooth transition
        transition: `width ${o} cubic-bezier(0.2, 0, 0, 1) 0s`,
        "ul, ol": {
          margin: 0,
          padding: 0,
          listStyle: "none"
        },
        // Overflow ellipsis
        "&-overflow": {
          display: "flex",
          [`${n}-item`]: {
            flex: "none"
          }
        },
        [`${n}-item, ${n}-submenu, ${n}-submenu-title`]: {
          borderRadius: e.itemBorderRadius
        },
        [`${n}-item-group-title`]: {
          padding: `${U(s)} ${U(c)}`,
          fontSize: C,
          lineHeight: u,
          transition: `all ${o}`
        },
        [`&-horizontal ${n}-submenu`]: {
          transition: [`border-color ${o} ${i}`, `background ${o} ${i}`].join(",")
        },
        [`${n}-submenu, ${n}-submenu-inline`]: {
          transition: [`border-color ${o} ${i}`, `background ${o} ${i}`, `padding ${a} ${i}`].join(",")
        },
        [`${n}-submenu ${n}-sub`]: {
          cursor: "initial",
          transition: [`background ${o} ${i}`, `padding ${o} ${i}`].join(",")
        },
        [`${n}-title-content`]: {
          transition: `color ${o}`,
          // https://github.com/ant-design/ant-design/issues/41143
          [`> ${t}-typography-ellipsis-single-line`]: {
            display: "inline",
            verticalAlign: "unset"
          }
        },
        [`${n}-item a`]: {
          "&::before": {
            position: "absolute",
            inset: 0,
            backgroundColor: "transparent",
            content: '""'
          }
        },
        // Removed a Badge related style seems it's safe
        // https://github.com/ant-design/ant-design/issues/19809
        // >>>>> Divider
        [`${n}-item-divider`]: {
          overflow: "hidden",
          lineHeight: 0,
          borderColor: f,
          borderStyle: b,
          borderWidth: 0,
          borderTopWidth: S,
          marginBlock: S,
          padding: 0,
          "&-dashed": {
            borderStyle: "dashed"
          }
        }
      }), Or(e)), {
        [`${n}-item-group`]: {
          [`${n}-item-group-list`]: {
            margin: 0,
            padding: 0,
            [`${n}-item, ${n}-submenu-title`]: {
              paddingInline: `${U(e.calc(r).mul(2).equal())} ${U(c)}`
            }
          }
        },
        // ======================= Sub Menu =======================
        "&-submenu": {
          "&-popup": {
            position: "absolute",
            zIndex: d,
            borderRadius: g,
            boxShadow: "none",
            transformOrigin: "0 0",
            [`&${n}-submenu`]: {
              background: "transparent"
            },
            // https://github.com/ant-design/ant-design/issues/13955
            "&::before": {
              position: "absolute",
              inset: 0,
              zIndex: -1,
              width: "100%",
              height: "100%",
              opacity: 0,
              content: '""'
            },
            [`> ${n}`]: Object.assign(Object.assign(Object.assign({
              borderRadius: g
            }, Or(e)), xr(e)), {
              [`${n}-item, ${n}-submenu > ${n}-submenu-title`]: {
                borderRadius: y
              },
              [`${n}-submenu-title::after`]: {
                transition: `transform ${o} ${i}`
              }
            })
          },
          "\n          &-placement-leftTop,\n          &-placement-bottomRight,\n          ": {
            transformOrigin: "100% 0"
          },
          "\n          &-placement-leftBottom,\n          &-placement-topRight,\n          ": {
            transformOrigin: "100% 100%"
          },
          "\n          &-placement-rightBottom,\n          &-placement-topLeft,\n          ": {
            transformOrigin: "0 100%"
          },
          "\n          &-placement-bottomLeft,\n          &-placement-rightTop,\n          ": {
            transformOrigin: "0 0"
          },
          "\n          &-placement-leftTop,\n          &-placement-leftBottom\n          ": {
            paddingInlineEnd: e.paddingXS
          },
          "\n          &-placement-rightTop,\n          &-placement-rightBottom\n          ": {
            paddingInlineStart: e.paddingXS
          },
          "\n          &-placement-topRight,\n          &-placement-topLeft\n          ": {
            paddingBottom: e.paddingXS
          },
          "\n          &-placement-bottomRight,\n          &-placement-bottomLeft\n          ": {
            paddingTop: e.paddingXS
          }
        }
      }), xr(e)), {
        [`&-inline-collapsed ${n}-submenu-arrow,
        &-inline ${n}-submenu-arrow`]: {
          // ↓
          "&::before": {
            transform: `rotate(-45deg) translateX(${U(m)})`
          },
          "&::after": {
            transform: `rotate(45deg) translateX(${U(e.calc(m).mul(-1).equal())})`
          }
        },
        [`${n}-submenu-open${n}-submenu-inline > ${n}-submenu-title > ${n}-submenu-arrow`]: {
          // ↑
          transform: `translateY(${U(e.calc(h).mul(0.2).mul(-1).equal())})`,
          "&::after": {
            transform: `rotate(-45deg) translateX(${U(e.calc(m).mul(-1).equal())})`
          },
          "&::before": {
            transform: `rotate(45deg) translateX(${U(m)})`
          }
        }
      })
    },
    // Integration with header element so menu items have the same height
    {
      [`${t}-layout-header`]: {
        [n]: {
          lineHeight: "inherit"
        }
      }
    }
  ];
}, Cs = (e) => {
  var t, n, r;
  const {
    colorPrimary: o,
    colorError: a,
    colorTextDisabled: i,
    colorErrorBg: s,
    colorText: c,
    colorTextDescription: f,
    colorBgContainer: S,
    colorFillAlter: d,
    colorFillContent: g,
    lineWidth: y,
    lineWidthBold: h,
    controlItemBgActive: m,
    colorBgTextHover: b,
    controlHeightLG: u,
    lineHeight: C,
    colorBgElevated: v,
    marginXXS: p,
    padding: $,
    fontSize: I,
    controlHeightSM: E,
    fontSizeLG: N,
    colorTextLightSolid: _,
    colorErrorHover: O
  } = e, M = (t = e.activeBarWidth) !== null && t !== void 0 ? t : 0, P = (n = e.activeBarBorderWidth) !== null && n !== void 0 ? n : y, w = (r = e.itemMarginInline) !== null && r !== void 0 ? r : e.marginXXS, x = new tr(_).setAlpha(0.65).toRgbString();
  return {
    dropdownWidth: 160,
    zIndexPopup: e.zIndexPopupBase + 50,
    radiusItem: e.borderRadiusLG,
    itemBorderRadius: e.borderRadiusLG,
    radiusSubMenuItem: e.borderRadiusSM,
    subMenuItemBorderRadius: e.borderRadiusSM,
    colorItemText: c,
    itemColor: c,
    colorItemTextHover: c,
    itemHoverColor: c,
    colorItemTextHoverHorizontal: o,
    horizontalItemHoverColor: o,
    colorGroupTitle: f,
    groupTitleColor: f,
    colorItemTextSelected: o,
    itemSelectedColor: o,
    colorItemTextSelectedHorizontal: o,
    horizontalItemSelectedColor: o,
    colorItemBg: S,
    itemBg: S,
    colorItemBgHover: b,
    itemHoverBg: b,
    colorItemBgActive: g,
    itemActiveBg: m,
    colorSubItemBg: d,
    subMenuItemBg: d,
    colorItemBgSelected: m,
    itemSelectedBg: m,
    colorItemBgSelectedHorizontal: "transparent",
    horizontalItemSelectedBg: "transparent",
    colorActiveBarWidth: 0,
    activeBarWidth: M,
    colorActiveBarHeight: h,
    activeBarHeight: h,
    colorActiveBarBorderSize: y,
    activeBarBorderWidth: P,
    // Disabled
    colorItemTextDisabled: i,
    itemDisabledColor: i,
    // Danger
    colorDangerItemText: a,
    dangerItemColor: a,
    colorDangerItemTextHover: a,
    dangerItemHoverColor: a,
    colorDangerItemTextSelected: a,
    dangerItemSelectedColor: a,
    colorDangerItemBgActive: s,
    dangerItemActiveBg: s,
    colorDangerItemBgSelected: s,
    dangerItemSelectedBg: s,
    itemMarginInline: w,
    horizontalItemBorderRadius: 0,
    horizontalItemHoverBg: "transparent",
    itemHeight: u,
    groupTitleLineHeight: C,
    collapsedWidth: u * 2,
    popupBg: v,
    itemMarginBlock: p,
    itemPaddingInline: $,
    horizontalLineHeight: `${u * 1.15}px`,
    iconSize: I,
    iconMarginInlineEnd: E - I,
    collapsedIconSize: N,
    groupTitleFontSize: I,
    // Disabled
    darkItemDisabledColor: new tr(_).setAlpha(0.25).toRgbString(),
    // Dark
    darkItemColor: x,
    darkDangerItemColor: a,
    darkItemBg: "#001529",
    darkPopupBg: "#001529",
    darkSubMenuItemBg: "#000c17",
    darkItemSelectedColor: _,
    darkItemSelectedBg: o,
    darkDangerItemSelectedBg: a,
    darkItemHoverBg: "transparent",
    darkGroupTitleColor: x,
    darkItemHoverColor: _,
    darkDangerItemHoverColor: O,
    darkDangerItemSelectedColor: _,
    darkDangerItemActiveBg: a,
    // internal
    itemWidth: M ? `calc(100% + ${P}px)` : `calc(100% - ${w * 2}px)`
  };
}, ys = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  return Dr("Menu", (o) => {
    const {
      colorBgElevated: a,
      controlHeightLG: i,
      fontSize: s,
      darkItemColor: c,
      darkDangerItemColor: f,
      darkItemBg: S,
      darkSubMenuItemBg: d,
      darkItemSelectedColor: g,
      darkItemSelectedBg: y,
      darkDangerItemSelectedBg: h,
      darkItemHoverBg: m,
      darkGroupTitleColor: b,
      darkItemHoverColor: u,
      darkItemDisabledColor: C,
      darkDangerItemHoverColor: v,
      darkDangerItemSelectedColor: p,
      darkDangerItemActiveBg: $,
      popupBg: I,
      darkPopupBg: E
    } = o, N = o.calc(s).div(7).mul(5).equal(), _ = yn(o, {
      menuArrowSize: N,
      menuHorizontalHeight: o.calc(i).mul(1.15).equal(),
      menuArrowOffset: o.calc(N).mul(0.25).equal(),
      menuSubMenuBg: a,
      calc: o.calc,
      popupBg: I
    }), O = yn(_, {
      itemColor: c,
      itemHoverColor: u,
      groupTitleColor: b,
      itemSelectedColor: g,
      itemBg: S,
      popupBg: E,
      subMenuItemBg: d,
      itemActiveBg: "transparent",
      itemSelectedBg: y,
      activeBarHeight: 0,
      activeBarBorderWidth: 0,
      itemHoverBg: m,
      // Disabled
      itemDisabledColor: C,
      // Danger
      dangerItemColor: f,
      dangerItemHoverColor: v,
      dangerItemSelectedColor: p,
      dangerItemActiveBg: $,
      dangerItemSelectedBg: h,
      menuSubMenuBg: d,
      // Horizontal
      horizontalItemSelectedColor: g,
      horizontalItemSelectedBg: y
    });
    return [
      // Basic
      bs(_),
      // Horizontal
      fs(_),
      // Hard code for some light style
      // Vertical
      hs(_),
      // Hard code for some light style
      // Theme
      _r(_, "light"),
      _r(O, "dark"),
      // RTL
      ps(_),
      // Motion
      la(_),
      Wt(_, "slide-up"),
      Wt(_, "slide-down"),
      Wr(_, "zoom-big")
    ];
  }, Cs, {
    deprecatedTokens: [["colorGroupTitle", "groupTitleColor"], ["radiusItem", "itemBorderRadius"], ["radiusSubMenuItem", "subMenuItemBorderRadius"], ["colorItemText", "itemColor"], ["colorItemTextHover", "itemHoverColor"], ["colorItemTextHoverHorizontal", "horizontalItemHoverColor"], ["colorItemTextSelected", "itemSelectedColor"], ["colorItemTextSelectedHorizontal", "horizontalItemSelectedColor"], ["colorItemTextDisabled", "itemDisabledColor"], ["colorDangerItemText", "dangerItemColor"], ["colorDangerItemTextHover", "dangerItemHoverColor"], ["colorDangerItemTextSelected", "dangerItemSelectedColor"], ["colorDangerItemBgActive", "dangerItemActiveBg"], ["colorDangerItemBgSelected", "dangerItemSelectedBg"], ["colorItemBg", "itemBg"], ["colorItemBgHover", "itemHoverBg"], ["colorSubItemBg", "subMenuItemBg"], ["colorItemBgActive", "itemActiveBg"], ["colorItemBgSelectedHorizontal", "horizontalItemSelectedBg"], ["colorActiveBarWidth", "activeBarWidth"], ["colorActiveBarHeight", "activeBarHeight"], ["colorActiveBarBorderSize", "activeBarBorderWidth"], ["colorItemBgSelected", "itemSelectedBg"]],
    // Dropdown will handle menu style self. We do not need to handle this.
    injectStyle: n,
    unitless: {
      groupTitleLineHeight: !0
    }
  })(e, t);
}, Es = (e) => {
  var t;
  const {
    popupClassName: n,
    icon: r,
    title: o,
    theme: a
  } = e, i = l.useContext(Yt), {
    prefixCls: s,
    inlineCollapsed: c,
    theme: f
  } = i, S = vt();
  let d;
  if (!r)
    d = c && !S.length && o && typeof o == "string" ? /* @__PURE__ */ l.createElement("div", {
      className: `${s}-inline-collapsed-noicon`
    }, o.charAt(0)) : /* @__PURE__ */ l.createElement("span", {
      className: `${s}-title-content`
    }, o);
  else {
    const h = /* @__PURE__ */ l.isValidElement(o) && o.type === "span";
    d = /* @__PURE__ */ l.createElement(l.Fragment, null, Zt(r, {
      className: F(/* @__PURE__ */ l.isValidElement(r) ? (t = r.props) === null || t === void 0 ? void 0 : t.className : "", `${s}-item-icon`)
    }), h ? o : /* @__PURE__ */ l.createElement("span", {
      className: `${s}-title-content`
    }, o));
  }
  const g = l.useMemo(() => Object.assign(Object.assign({}, i), {
    firstLevel: !1
  }), [i]), [y] = Kr("Menu");
  return /* @__PURE__ */ l.createElement(Yt.Provider, {
    value: g
  }, /* @__PURE__ */ l.createElement(Pt, Object.assign({}, Rt(e, ["icon"]), {
    title: d,
    popupClassName: F(s, n, `${s}-${a || f}`),
    popupStyle: {
      zIndex: y
    }
  })));
}, Uo = Es;
var Ss = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function hn(e) {
  return e === null || e === !1;
}
const $s = {
  item: jo,
  submenu: Uo,
  divider: Ko
}, Is = /* @__PURE__ */ Pn((e, t) => {
  var n;
  const r = l.useContext(qt), o = r || {}, {
    getPrefixCls: a,
    getPopupContainer: i,
    direction: s,
    menu: c
  } = l.useContext(it), f = a(), {
    prefixCls: S,
    className: d,
    style: g,
    theme: y = "light",
    expandIcon: h,
    _internalDisableMenuItemTitleTooltip: m,
    inlineCollapsed: b,
    siderCollapsed: u,
    rootClassName: C,
    mode: v,
    selectable: p,
    onClick: $,
    overflowedIndicatorPopupClassName: I
  } = e, E = Ss(e, ["prefixCls", "className", "style", "theme", "expandIcon", "_internalDisableMenuItemTitleTooltip", "inlineCollapsed", "siderCollapsed", "rootClassName", "mode", "selectable", "onClick", "overflowedIndicatorPopupClassName"]), N = Rt(E, ["collapsedWidth"]);
  if (process.env.NODE_ENV !== "production") {
    const L = jr("Menu");
    process.env.NODE_ENV !== "production" && L(!("inlineCollapsed" in e && v !== "inline"), "usage", "`inlineCollapsed` should only be used when `mode` is inline."), process.env.NODE_ENV !== "production" && L(!(e.siderCollapsed !== void 0 && "inlineCollapsed" in e), "usage", "`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead."), L.deprecated("items" in e && !e.children, "children", "items");
  }
  (n = o.validator) === null || n === void 0 || n.call(o, {
    mode: v
  });
  const _ = Tr(function() {
    var L;
    $ == null || $.apply(void 0, arguments), (L = o.onClick) === null || L === void 0 || L.call(o);
  }), O = o.mode || v, M = p ?? o.selectable, P = l.useMemo(() => u !== void 0 ? u : b, [b, u]), w = {
    horizontal: {
      motionName: `${f}-slide-up`
    },
    inline: Ai(f),
    other: {
      motionName: `${f}-zoom-big`
    }
  }, x = a("menu", S || o.prefixCls), B = Ur(x), [K, j, V] = ys(x, B, !r), k = F(`${x}-${y}`, c == null ? void 0 : c.className, d), G = l.useMemo(() => {
    var L, X;
    if (typeof h == "function" || hn(h))
      return h || null;
    if (typeof o.expandIcon == "function" || hn(o.expandIcon))
      return o.expandIcon || null;
    if (typeof (c == null ? void 0 : c.expandIcon) == "function" || hn(c == null ? void 0 : c.expandIcon))
      return (c == null ? void 0 : c.expandIcon) || null;
    const q = (L = h ?? (o == null ? void 0 : o.expandIcon)) !== null && L !== void 0 ? L : c == null ? void 0 : c.expandIcon;
    return Zt(q, {
      className: F(`${x}-submenu-expand-icon`, /* @__PURE__ */ l.isValidElement(q) ? (X = q.props) === null || X === void 0 ? void 0 : X.className : void 0)
    });
  }, [h, o == null ? void 0 : o.expandIcon, c == null ? void 0 : c.expandIcon, x]), ne = l.useMemo(() => ({
    prefixCls: x,
    inlineCollapsed: P || !1,
    direction: s,
    firstLevel: !0,
    theme: y,
    mode: O,
    disableMenuItemTitleTooltip: m
  }), [x, P, s, m, y]);
  return K(/* @__PURE__ */ l.createElement(qt.Provider, {
    value: null
  }, /* @__PURE__ */ l.createElement(Yt.Provider, {
    value: ne
  }, /* @__PURE__ */ l.createElement(Tt, Object.assign({
    getPopupContainer: i,
    overflowedIndicator: /* @__PURE__ */ l.createElement(Lo, null),
    overflowedIndicatorPopupClassName: F(x, `${x}-${y}`, I),
    mode: O,
    selectable: M,
    onClick: _
  }, N, {
    inlineCollapsed: P,
    style: Object.assign(Object.assign({}, c == null ? void 0 : c.style), g),
    className: k,
    prefixCls: x,
    direction: s,
    defaultMotions: w,
    expandIcon: G,
    ref: t,
    rootClassName: F(C, j, o.rootClassName, V, B),
    _internalComponents: $s
  })))));
}), ws = Is, gt = /* @__PURE__ */ Pn((e, t) => {
  const n = pt(null), r = l.useContext(zn);
  return Br(t, () => ({
    menu: n.current,
    focus: (o) => {
      var a;
      (a = n.current) === null || a === void 0 || a.focus(o);
    }
  })), /* @__PURE__ */ l.createElement(ws, Object.assign({
    ref: n
  }, e, r));
});
gt.Item = jo;
gt.SubMenu = Uo;
gt.Divider = Ko;
gt.ItemGroup = cn;
process.env.NODE_ENV !== "production" && (gt.displayName = "Menu");
const _s = gt, Ns = (e) => {
  const {
    componentCls: t,
    menuCls: n,
    colorError: r,
    colorTextLightSolid: o
  } = e, a = `${n}-item`;
  return {
    [`${t}, ${t}-menu-submenu`]: {
      [`${n} ${a}`]: {
        [`&${a}-danger:not(${a}-disabled)`]: {
          color: r,
          "&:hover": {
            color: o,
            backgroundColor: r
          }
        }
      }
    }
  };
}, Os = Ns, xs = (e) => {
  const {
    componentCls: t,
    menuCls: n,
    zIndexPopup: r,
    dropdownArrowDistance: o,
    sizePopupArrow: a,
    antCls: i,
    iconCls: s,
    motionDurationMid: c,
    paddingBlock: f,
    fontSize: S,
    dropdownEdgeChildPadding: d,
    colorTextDisabled: g,
    fontSizeIcon: y,
    controlPaddingHorizontal: h,
    colorBgElevated: m
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign({}, Lr(e)), {
        position: "absolute",
        top: -9999,
        left: {
          _skip_check_: !0,
          value: -9999
        },
        zIndex: r,
        display: "block",
        // A placeholder out of dropdown visible range to avoid close when user moving
        "&::before": {
          position: "absolute",
          insetBlock: e.calc(a).div(2).sub(o).equal(),
          // insetInlineStart: -7, // FIXME: Seems not work for hidden element
          zIndex: -9999,
          opacity: 1e-4,
          content: '""'
        },
        [`&-trigger${i}-btn`]: {
          [`& > ${s}-down, & > ${i}-btn-icon > ${s}-down`]: {
            fontSize: y
          }
        },
        [`${t}-wrap`]: {
          position: "relative",
          [`${i}-btn > ${s}-down`]: {
            fontSize: y
          },
          [`${s}-down::before`]: {
            transition: `transform ${c}`
          }
        },
        [`${t}-wrap-open`]: {
          [`${s}-down::before`]: {
            transform: "rotate(180deg)"
          }
        },
        "\n        &-hidden,\n        &-menu-hidden,\n        &-menu-submenu-hidden\n      ": {
          display: "none"
        },
        // =============================================================
        // ==                         Motion                          ==
        // =============================================================
        // When position is not enough for dropdown, the placement will revert.
        // We will handle this with revert motion name.
        [`&${i}-slide-down-enter${i}-slide-down-enter-active${t}-placement-bottomLeft,
          &${i}-slide-down-appear${i}-slide-down-appear-active${t}-placement-bottomLeft,
          &${i}-slide-down-enter${i}-slide-down-enter-active${t}-placement-bottom,
          &${i}-slide-down-appear${i}-slide-down-appear-active${t}-placement-bottom,
          &${i}-slide-down-enter${i}-slide-down-enter-active${t}-placement-bottomRight,
          &${i}-slide-down-appear${i}-slide-down-appear-active${t}-placement-bottomRight`]: {
          animationName: Jr
        },
        [`&${i}-slide-up-enter${i}-slide-up-enter-active${t}-placement-topLeft,
          &${i}-slide-up-appear${i}-slide-up-appear-active${t}-placement-topLeft,
          &${i}-slide-up-enter${i}-slide-up-enter-active${t}-placement-top,
          &${i}-slide-up-appear${i}-slide-up-appear-active${t}-placement-top,
          &${i}-slide-up-enter${i}-slide-up-enter-active${t}-placement-topRight,
          &${i}-slide-up-appear${i}-slide-up-appear-active${t}-placement-topRight`]: {
          animationName: to
        },
        [`&${i}-slide-down-leave${i}-slide-down-leave-active${t}-placement-bottomLeft,
          &${i}-slide-down-leave${i}-slide-down-leave-active${t}-placement-bottom,
          &${i}-slide-down-leave${i}-slide-down-leave-active${t}-placement-bottomRight`]: {
          animationName: eo
        },
        [`&${i}-slide-up-leave${i}-slide-up-leave-active${t}-placement-topLeft,
          &${i}-slide-up-leave${i}-slide-up-leave-active${t}-placement-top,
          &${i}-slide-up-leave${i}-slide-up-leave-active${t}-placement-topRight`]: {
          animationName: no
        }
      })
    },
    // =============================================================
    // ==                        Arrow style                      ==
    // =============================================================
    Bi(e, m, {
      arrowPlacement: {
        top: !0,
        bottom: !0
      }
    }),
    {
      // =============================================================
      // ==                          Menu                           ==
      // =============================================================
      [`${t} ${n}`]: {
        position: "relative",
        margin: 0
      },
      [`${n}-submenu-popup`]: {
        position: "absolute",
        zIndex: r,
        background: "transparent",
        boxShadow: "none",
        transformOrigin: "0 0",
        "ul, li": {
          listStyle: "none",
          margin: 0
        }
      },
      [`${t}, ${t}-menu-submenu`]: {
        [n]: Object.assign(Object.assign({
          padding: d,
          listStyleType: "none",
          backgroundColor: m,
          backgroundClip: "padding-box",
          borderRadius: e.borderRadiusLG,
          outline: "none",
          boxShadow: e.boxShadowSecondary
        }, or(e)), {
          "&:empty": {
            padding: 0,
            boxShadow: "none"
          },
          [`${n}-item-group-title`]: {
            padding: `${U(f)} ${U(h)}`,
            color: e.colorTextDescription,
            transition: `all ${c}`
          },
          // ======================= Item Content =======================
          [`${n}-item`]: {
            position: "relative",
            display: "flex",
            alignItems: "center"
          },
          [`${n}-item-icon`]: {
            minWidth: S,
            marginInlineEnd: e.marginXS,
            fontSize: e.fontSizeSM
          },
          [`${n}-title-content`]: {
            flex: "auto",
            "> a": {
              color: "inherit",
              transition: `all ${c}`,
              "&:hover": {
                color: "inherit"
              },
              "&::after": {
                position: "absolute",
                inset: 0,
                content: '""'
              }
            }
          },
          // =========================== Item ===========================
          [`${n}-item, ${n}-submenu-title`]: Object.assign(Object.assign({
            clear: "both",
            margin: 0,
            padding: `${U(f)} ${U(h)}`,
            color: e.colorText,
            fontWeight: "normal",
            fontSize: S,
            lineHeight: e.lineHeight,
            cursor: "pointer",
            transition: `all ${c}`,
            borderRadius: e.borderRadiusSM,
            "&:hover, &-active": {
              backgroundColor: e.controlItemBgHover
            }
          }, or(e)), {
            "&-selected": {
              color: e.colorPrimary,
              backgroundColor: e.controlItemBgActive,
              "&:hover, &-active": {
                backgroundColor: e.controlItemBgActiveHover
              }
            },
            "&-disabled": {
              color: g,
              cursor: "not-allowed",
              "&:hover": {
                color: g,
                backgroundColor: m,
                cursor: "not-allowed"
              },
              a: {
                pointerEvents: "none"
              }
            },
            "&-divider": {
              height: 1,
              // By design
              margin: `${U(e.marginXXS)} 0`,
              overflow: "hidden",
              lineHeight: 0,
              backgroundColor: e.colorSplit
            },
            [`${t}-menu-submenu-expand-icon`]: {
              position: "absolute",
              insetInlineEnd: e.paddingXS,
              [`${t}-menu-submenu-arrow-icon`]: {
                marginInlineEnd: "0 !important",
                color: e.colorTextDescription,
                fontSize: y,
                fontStyle: "normal"
              }
            }
          }),
          [`${n}-item-group-list`]: {
            margin: `0 ${U(e.marginXS)}`,
            padding: 0,
            listStyle: "none"
          },
          [`${n}-submenu-title`]: {
            paddingInlineEnd: e.calc(h).add(e.fontSizeSM).equal()
          },
          [`${n}-submenu-vertical`]: {
            position: "relative"
          },
          [`${n}-submenu${n}-submenu-disabled ${t}-menu-submenu-title`]: {
            [`&, ${t}-menu-submenu-arrow-icon`]: {
              color: g,
              backgroundColor: m,
              cursor: "not-allowed"
            }
          },
          // https://github.com/ant-design/ant-design/issues/19264
          [`${n}-submenu-selected ${t}-menu-submenu-title`]: {
            color: e.colorPrimary
          }
        })
      }
    },
    // Follow code may reuse in other components
    [Wt(e, "slide-up"), Wt(e, "slide-down"), sr(e, "move-up"), sr(e, "move-down"), Wr(e, "zoom-big")]
  ];
}, Rs = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 50,
  paddingBlock: (e.controlHeight - e.fontSize * e.lineHeight) / 2
}, Di({
  contentRadius: e.borderRadiusLG,
  limitVerticalRadius: !0
})), Li(e)), Ms = Dr("Dropdown", (e) => {
  const {
    marginXXS: t,
    sizePopupArrow: n,
    paddingXXS: r,
    componentCls: o
  } = e, a = yn(e, {
    menuCls: `${o}-menu`,
    dropdownArrowDistance: e.calc(n).div(2).add(t).equal(),
    dropdownEdgeChildPadding: r
  });
  return [xs(a), Os(a)];
}, Rs, {
  resetStyle: !1
}), un = (e) => {
  const {
    menu: t,
    arrow: n,
    prefixCls: r,
    children: o,
    trigger: a,
    disabled: i,
    dropdownRender: s,
    getPopupContainer: c,
    overlayClassName: f,
    rootClassName: S,
    overlayStyle: d,
    open: g,
    onOpenChange: y,
    // Deprecated
    visible: h,
    onVisibleChange: m,
    mouseEnterDelay: b = 0.15,
    mouseLeaveDelay: u = 0.1,
    autoAdjustOverflow: C = !0,
    placement: v = "",
    overlay: p,
    transitionName: $
  } = e, {
    getPopupContainer: I,
    getPrefixCls: E,
    direction: N,
    dropdown: _
  } = l.useContext(it), O = jr("Dropdown");
  process.env.NODE_ENV !== "production" && ([["visible", "open"], ["onVisibleChange", "onOpenChange"]].forEach((z) => {
    let [pe, ue] = z;
    O.deprecated(!(pe in e), pe, ue);
  }), O.deprecated(!("overlay" in e), "overlay", "menu"));
  const M = l.useMemo(() => {
    const z = E();
    return $ !== void 0 ? $ : v.includes("top") ? `${z}-slide-down` : `${z}-slide-up`;
  }, [E, v, $]), P = l.useMemo(() => v ? v.includes("Center") ? v.slice(0, v.indexOf("Center")) : v : N === "rtl" ? "bottomRight" : "bottomLeft", [v, N]);
  if (process.env.NODE_ENV !== "production") {
    if (v.includes("Center")) {
      const z = v.slice(0, v.indexOf("Center"));
      process.env.NODE_ENV !== "production" && O(!v.includes("Center"), "deprecated", `You are using '${v}' placement in Dropdown, which is deprecated. Try to use '${z}' instead.`);
    }
    [["visible", "open"], ["onVisibleChange", "onOpenChange"]].forEach((z) => {
      let [pe, ue] = z;
      O.deprecated(!(pe in e), pe, ue);
    });
  }
  const w = E("dropdown", r), x = Ur(w), [B, K, j] = Ms(w, x), [, V] = xi(), k = l.Children.only(o), G = Zt(k, {
    className: F(`${w}-trigger`, {
      [`${w}-rtl`]: N === "rtl"
    }, k.props.className),
    disabled: i
  }), ne = i ? [] : a;
  let L;
  ne && ne.includes("contextMenu") && (L = !0);
  const [X, q] = Zr(!1, {
    value: g ?? h
  }), Z = Tr((z) => {
    y == null || y(z, {
      source: "trigger"
    }), m == null || m(z), q(z);
  }), J = F(f, S, K, j, x, _ == null ? void 0 : _.className, {
    [`${w}-rtl`]: N === "rtl"
  }), ae = Ki({
    arrowPointAtCenter: typeof n == "object" && n.pointAtCenter,
    autoAdjustOverflow: C,
    offset: V.marginXXS,
    arrowWidth: n ? V.sizePopupArrow : 0,
    borderRadius: V.borderRadius
  }), ee = l.useCallback(() => {
    t != null && t.selectable && (t != null && t.multiple) || (y == null || y(!1, {
      source: "menu"
    }), q(!1));
  }, [t == null ? void 0 : t.selectable, t == null ? void 0 : t.multiple]), fe = () => {
    let z;
    return t != null && t.items ? z = /* @__PURE__ */ l.createElement(_s, Object.assign({}, t)) : typeof p == "function" ? z = p() : z = p, s && (z = s(z)), z = l.Children.only(typeof z == "string" ? /* @__PURE__ */ l.createElement("span", null, z) : z), /* @__PURE__ */ l.createElement(us, {
      prefixCls: `${w}-menu`,
      rootClassName: F(j, x),
      expandIcon: /* @__PURE__ */ l.createElement("span", {
        className: `${w}-menu-submenu-arrow`
      }, /* @__PURE__ */ l.createElement(Sn, {
        className: `${w}-menu-submenu-arrow-icon`
      })),
      mode: "vertical",
      selectable: !1,
      onClick: ee,
      validator: (pe) => {
        let {
          mode: ue
        } = pe;
        process.env.NODE_ENV !== "production" && O(!ue || ue === "vertical", "usage", `mode="${ue}" is not supported for Dropdown's Menu.`);
      }
    }, z);
  }, [le, be] = Kr("Dropdown", d == null ? void 0 : d.zIndex);
  let me = /* @__PURE__ */ l.createElement(qa, Object.assign({
    alignPoint: L
  }, Rt(e, ["rootClassName"]), {
    mouseEnterDelay: b,
    mouseLeaveDelay: u,
    visible: X,
    builtinPlacements: ae,
    arrow: !!n,
    overlayClassName: J,
    prefixCls: w,
    getPopupContainer: c || I,
    transitionName: M,
    trigger: ne,
    overlay: fe,
    placement: P,
    onVisibleChange: Z,
    overlayStyle: Object.assign(Object.assign(Object.assign({}, _ == null ? void 0 : _.style), d), {
      zIndex: le
    })
  }), G);
  return le && (me = /* @__PURE__ */ l.createElement(Ri.Provider, {
    value: be
  }, me)), B(me);
};
function Ps(e) {
  return Object.assign(Object.assign({}, e), {
    align: {
      overflow: {
        adjustX: !1,
        adjustY: !1
      }
    }
  });
}
const Ts = Ia(un, "dropdown", (e) => e, Ps), As = (e) => /* @__PURE__ */ l.createElement(Ts, Object.assign({}, e), /* @__PURE__ */ l.createElement("span", null));
un._InternalPanelDoNotUseOrYouWillBeFired = As;
process.env.NODE_ENV !== "production" && (un.displayName = "Dropdown");
const ko = un;
function Rr(e) {
  return ["small", "middle", "large"].includes(e);
}
function Mr(e) {
  return e ? typeof e == "number" && !Number.isNaN(e) : !1;
}
const zo = /* @__PURE__ */ ve.createContext({
  latestIndex: 0
}), Bs = zo.Provider, Ds = (e) => {
  let {
    className: t,
    index: n,
    children: r,
    split: o,
    style: a
  } = e;
  const {
    latestIndex: i
  } = l.useContext(zo);
  return r == null ? null : /* @__PURE__ */ l.createElement(l.Fragment, null, /* @__PURE__ */ l.createElement("div", {
    className: t,
    style: a
  }, r), n < i && o && /* @__PURE__ */ l.createElement("span", {
    className: `${t}-split`
  }, o));
}, Ls = Ds;
var Ks = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const js = /* @__PURE__ */ l.forwardRef((e, t) => {
  var n, r, o;
  const {
    getPrefixCls: a,
    space: i,
    direction: s
  } = l.useContext(it), {
    size: c = (n = i == null ? void 0 : i.size) !== null && n !== void 0 ? n : "small",
    align: f,
    className: S,
    rootClassName: d,
    children: g,
    direction: y = "horizontal",
    prefixCls: h,
    split: m,
    style: b,
    wrap: u = !1,
    classNames: C,
    styles: v
  } = e, p = Ks(e, ["size", "align", "className", "rootClassName", "children", "direction", "prefixCls", "split", "style", "wrap", "classNames", "styles"]), [$, I] = Array.isArray(c) ? c : [c, c], E = Rr(I), N = Rr($), _ = Mr(I), O = Mr($), M = Fr(g, {
    keepEmpty: !0
  }), P = f === void 0 && y === "horizontal" ? "center" : f, w = a("space", h), [x, B, K] = Ui(w), j = F(w, i == null ? void 0 : i.className, B, `${w}-${y}`, {
    [`${w}-rtl`]: s === "rtl",
    [`${w}-align-${P}`]: P,
    [`${w}-gap-row-${I}`]: E,
    [`${w}-gap-col-${$}`]: N
  }, S, d, K), V = F(`${w}-item`, (r = C == null ? void 0 : C.item) !== null && r !== void 0 ? r : (o = i == null ? void 0 : i.classNames) === null || o === void 0 ? void 0 : o.item);
  let k = 0;
  const G = M.map((X, q) => {
    var Z, J;
    X != null && (k = q);
    const ae = X && X.key || `${V}-${q}`;
    return /* @__PURE__ */ l.createElement(Ls, {
      className: V,
      key: ae,
      index: q,
      split: m,
      style: (Z = v == null ? void 0 : v.item) !== null && Z !== void 0 ? Z : (J = i == null ? void 0 : i.styles) === null || J === void 0 ? void 0 : J.item
    }, X);
  }), ne = l.useMemo(() => ({
    latestIndex: k
  }), [k]);
  if (M.length === 0)
    return null;
  const L = {};
  return u && (L.flexWrap = "wrap"), !N && O && (L.columnGap = $), !E && _ && (L.rowGap = I), x(/* @__PURE__ */ l.createElement("div", Object.assign({
    ref: t,
    className: j,
    style: Object.assign(Object.assign(Object.assign({}, L), i == null ? void 0 : i.style), b)
  }, p), /* @__PURE__ */ l.createElement(Bs, {
    value: ne
  }, G)));
}), Hn = js;
Hn.Compact = ji;
process.env.NODE_ENV !== "production" && (Hn.displayName = "Space");
const Us = Hn;
var ks = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Ho = (e) => {
  const {
    getPopupContainer: t,
    getPrefixCls: n,
    direction: r
  } = l.useContext(it), {
    prefixCls: o,
    type: a = "default",
    danger: i,
    disabled: s,
    loading: c,
    onClick: f,
    htmlType: S,
    children: d,
    className: g,
    menu: y,
    arrow: h,
    autoFocus: m,
    overlay: b,
    trigger: u,
    align: C,
    open: v,
    onOpenChange: p,
    placement: $,
    getPopupContainer: I,
    href: E,
    icon: N = /* @__PURE__ */ l.createElement(Lo, null),
    title: _,
    buttonsRender: O = (ee) => ee,
    mouseEnterDelay: M,
    mouseLeaveDelay: P,
    overlayClassName: w,
    overlayStyle: x,
    destroyPopupOnHide: B,
    dropdownRender: K
  } = e, j = ks(e, ["prefixCls", "type", "danger", "disabled", "loading", "onClick", "htmlType", "children", "className", "menu", "arrow", "autoFocus", "overlay", "trigger", "align", "open", "onOpenChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender", "mouseEnterDelay", "mouseLeaveDelay", "overlayClassName", "overlayStyle", "destroyPopupOnHide", "dropdownRender"]), V = n("dropdown", o), k = `${V}-button`, G = {
    menu: y,
    arrow: h,
    autoFocus: m,
    align: C,
    disabled: s,
    trigger: s ? [] : u,
    onOpenChange: p,
    getPopupContainer: I || t,
    mouseEnterDelay: M,
    mouseLeaveDelay: P,
    overlayClassName: w,
    overlayStyle: x,
    destroyPopupOnHide: B,
    dropdownRender: K
  }, {
    compactSize: ne,
    compactItemClassnames: L
  } = ki(V, r), X = F(k, L, g);
  "overlay" in e && (G.overlay = b), "open" in e && (G.open = v), "placement" in e ? G.placement = $ : G.placement = r === "rtl" ? "bottomLeft" : "bottomRight";
  const q = /* @__PURE__ */ l.createElement(ir, {
    type: a,
    danger: i,
    disabled: s,
    loading: c,
    onClick: f,
    htmlType: S,
    href: E,
    title: _
  }, d), Z = /* @__PURE__ */ l.createElement(ir, {
    type: a,
    danger: i,
    icon: N
  }), [J, ae] = O([q, Z]);
  return /* @__PURE__ */ l.createElement(Us.Compact, Object.assign({
    className: X,
    size: ne,
    block: !0
  }, j), J, /* @__PURE__ */ l.createElement(ko, Object.assign({}, G), ae));
};
Ho.__ANT_BUTTON = !0;
const zs = Ho, Fo = ko;
Fo.Button = zs;
const Hs = Fo, Fs = "_antBtnBase_1xwg6_1", Vs = "_circleBtn_1xwg6_24", Ws = "_fbBtn_1xwg6_47", Gs = "_lineBtn_1xwg6_58", Xs = "_appleBtn_1xwg6_67", Ys = "_XBtn_1xwg6_72", qs = "_googleBtn_1xwg6_83", Qs = "_antPrimaryBtn_1xwg6_97", et = {
  antBtnBase: Fs,
  circleBtn: Vs,
  fbBtn: Ws,
  lineBtn: Gs,
  appleBtn: Xs,
  XBtn: Ys,
  googleBtn: qs,
  antPrimaryBtn: Qs
}, Zs = (e) => {
  let t;
  switch (e) {
    case "fb":
      t = et.fbBtn;
      break;
    case "line":
      t = et.lineBtn;
      break;
    case "apple":
      t = et.appleBtn;
      break;
    case "X":
      t = et.XBtn;
      break;
    case "google":
      t = et.googleBtn;
      break;
    default:
      t = "";
      break;
  }
  return t;
}, at = (e) => {
  const { className: t, shape: n, socialType: r, children: o, useBaseStyle: a, onClick: i } = e, s = a ? "" : Zs(r);
  return /* @__PURE__ */ A.jsx("div", { onClick: i, className: F(et.antBtnBase, n === "circle" ? et.circleBtn : "", s, t), children: o });
}, lt = ({ text: e, isInDropdown: t = !1 }) => t ? e : /* @__PURE__ */ A.jsx("span", { children: e }), Js = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js", ec = (e) => {
  var b;
  const {
    lang: { getStarted: t },
    showTitle: n = !1,
    isInDropdown: r,
    ...o
  } = e, a = rt(), [i, s] = Me(!1), { defaultLoginCallBack: c, handleAuthSocialLogin: f } = xt(), S = ot(), d = {};
  for (const u of a.entries())
    d[u[0]] = u[1];
  const g = () => {
    S.push("/get-started/connect/email", {
      type: Ee.APPLE,
      ...d ?? {}
    });
  };
  Pe(() => {
    s(typeof (window == null ? void 0 : window.AppleID) < "u");
  }, [window == null ? void 0 : window.AppleID]);
  const y = {
    clientId: "com.bossjob.web",
    scope: "name email",
    redirectURI: `${location.origin}/get-started`,
    usePopup: !0
  };
  Pe(() => {
    if (typeof window < "u") {
      if (window.AppleID)
        return;
      const u = document.createElement("script"), C = () => {
        var v;
        window != null && window.AppleID && (s(!0), window.AppleID.auth.init(y), (v = document == null ? void 0 : document.body) == null || v.removeChild(u));
      };
      u.src = Js, u.type = "text/javascript", u.async = !0, u.defer = !0, u.onload = C, u.onerror = () => {
        s(!1);
      }, window != null && window.AppleID || document.body.appendChild(u);
    }
  }, []);
  const h = async () => {
    if (window != null && window.AppleID)
      try {
        const u = await window.AppleID.auth.signIn();
        m(u);
      } catch {
      }
  }, m = (u) => {
    var C, v, p;
    try {
      const $ = Qi((C = u == null ? void 0 : u.authorization) == null ? void 0 : C.id_token), I = a.get("referral_code"), E = a.get("invited_source"), N = u.email ?? ((v = u == null ? void 0 : u.user) == null ? void 0 : v.email) ?? "", _ = {
        ...u,
        ...d,
        email: N,
        social_user_token: (p = u == null ? void 0 : u.authorization) == null ? void 0 : p.id_token,
        social_type: "apple",
        social_user_id: $.sub || "",
        source: Re ? "mobile_web" : "web",
        referral_code: I || void 0,
        invited_source: E || void 0
      }, O = (M) => {
        f(M).then((P) => {
          P != null && P.token && c(P);
        });
      };
      if (!_.email) {
        ((P) => {
          Mt({
            social_type: Ee.APPLE,
            social_user_id: P.social_user_id
          }).then((w) => {
            var B;
            const x = (B = w == null ? void 0 : w.data) == null ? void 0 : B.email;
            x ? O({
              ...P,
              email: x
            }) : (Jt(Ji, { data: _ }), g());
          }).catch((w) => {
          });
        })(_);
        return;
      }
      O(_);
    } catch {
    }
  };
  return /* @__PURE__ */ A.jsxs(
    at,
    {
      ...o,
      socialType: "apple",
      className: i ? "" : zi.login_disabled,
      onClick: h,
      children: [
        /* @__PURE__ */ A.jsx(Hi, {}),
        n && /* @__PURE__ */ A.jsx(lt, { isInDropdown: r, text: (b = t == null ? void 0 : t.links) == null ? void 0 : b.apple })
      ]
    }
  );
}, tc = "_socialContent_1blr6_1", nc = "_lineBtn_1blr6_1", rc = "_emailBtn_1blr6_2", oc = "_phoneBtn_1blr6_3", ic = "_socialContentBottom_1blr6_50", ac = "_or_1blr6_67", lc = "_text_1blr6_81", sc = "_loginMoreDropdown_1blr6_86", cc = "_loginMoreBtn_1blr6_110", uc = "_moreIcon_1blr6_124", He = {
  socialContent: tc,
  lineBtn: nc,
  emailBtn: rc,
  phoneBtn: oc,
  socialContentBottom: ic,
  or: ac,
  text: lc,
  loginMoreDropdown: sc,
  loginMoreBtn: cc,
  moreIcon: uc
}, dc = (e) => {
  var d;
  const {
    lang: { getStarted: t },
    handleClick: n,
    isModal: r,
    isInDropdown: o,
    ...a
  } = e, i = Ar(), { showTitle: s } = e, c = ot(), f = rt(), S = () => {
    const g = f.get("referral_code"), y = f.get("invited_source");
    r ? n() : g && y ? c.push(`/${i}/get-started/email?referral_code=${g}&invited_source=${y}`) : c.push(`/${i}/get-started/email`);
  };
  return /* @__PURE__ */ A.jsxs(
    at,
    {
      ...a,
      shape: "circle",
      className: He.emailBtn,
      onClick: () => S(),
      children: [
        /* @__PURE__ */ A.jsx(Fi, {}),
        s && /* @__PURE__ */ A.jsx(lt, { isInDropdown: o, text: (d = t == null ? void 0 : t.links) == null ? void 0 : d.email })
      ]
    }
  );
}, fc = (e) => {
  const {
    activeKey: t,
    isLogin: n,
    redirect: r,
    lang: { getStarted: o },
    showTitle: a = !0,
    useBaseStyle: i,
    isInDropdown: s,
    ...c
  } = e, f = rt(), { defaultLoginCallBack: S, handleAuthSocialLogin: d } = xt(), g = {}, y = ot();
  for (const C of f.entries())
    g[C[0]] = C[1];
  const h = () => {
    y.push("/get-started/connect/email", {
      type: Ee.FB,
      ...g ?? {}
    });
  }, m = (C) => {
    const v = f.get("referral_code"), p = f.get("invited_source"), $ = {
      ...C,
      ...g,
      email: C.email ? C.email : "",
      social_user_token: C.accessToken,
      social_type: C.socialType,
      social_user_id: C.userId,
      source: Re ? "mobile_web" : "web",
      referral_code: v || void 0,
      invited_source: p || void 0
    };
    C.pictureUrl && ($.avatar = C.pictureUrl), d($).then((I) => {
      I != null && I.token && S(I);
    });
  }, b = () => {
    let C;
    typeof (window == null ? void 0 : window.FB) > "u" || window.FB.login(
      function(v) {
        v.authResponse && (C = v.authResponse.accessToken, window.FB.api("/me?fields=id,first_name,last_name,email", function(p) {
          const $ = {
            userId: p.id,
            firstName: p.first_name,
            lastName: p.last_name,
            email: p.email,
            pictureUrl: p.profile_pic,
            accessToken: C,
            socialType: Ee.FB,
            redirect: r,
            activeKey: t || null,
            isLogin: !!n
          };
          if (!p.email) {
            ((E) => {
              Mt({
                social_type: Ee.FB,
                social_user_id: E.userId
              }).then((N) => {
                var O;
                const _ = (O = N == null ? void 0 : N.data) == null ? void 0 : O.email;
                _ ? m({
                  ...E,
                  email: _
                }) : (Jt(ea, { data: E }), h());
              }).catch((N) => {
              });
            })($);
            return;
          }
          m($);
        }));
      },
      {
        scope: "email"
      }
    );
  }, u = (() => s ? "#000" : a ? "#fff" : "#000")();
  return /* @__PURE__ */ A.jsxs(
    at,
    {
      ...c,
      useBaseStyle: i,
      socialType: "fb",
      onClick: b,
      children: [
        /* @__PURE__ */ A.jsx(Vi, { color: u }),
        a && /* @__PURE__ */ A.jsx(lt, { isInDropdown: s, text: o.links.facebook })
      ]
    }
  );
}, mc = (e) => {
  const {
    activeKey: t,
    isLogin: n,
    redirect: r,
    lang: { getStarted: o },
    showTitle: a = !0,
    useBaseStyle: i,
    isInDropdown: s,
    ...c
  } = e, { defaultLoginCallBack: f, handleAuthSocialLogin: S } = xt(), [d, g] = Me(!1), y = rt(), h = ot(), m = {};
  for (const p of y.entries())
    m[p[0]] = p[1];
  const b = () => {
    h.push("/get-started/connect/email", {
      type: Ee.GOOGLE,
      ...m ?? {}
    });
  };
  Pe(() => {
    g(typeof (window == null ? void 0 : window.gAPIAuthInstance) < "u");
  }, [window == null ? void 0 : window.gAPIAuthInstance]), Pe(() => {
    if (typeof window < "u") {
      if (window.gAPIAuthInstance)
        return;
      const p = document.createElement("script"), $ = () => window.gapi.load("client:auth2", I), I = () => {
        var E, N;
        window.gapi.client.init({
          // apiKey: 'AIzaSyAFYSp8vzxmXF_PourfSFW6t0VynH5d9Vs',
          clientId: "197019623682-n8mch4vlad6r9c6t3vhovu01sartbahq.apps.googleusercontent.com",
          scope: "https://www.googleapis.com/auth/userinfo.profile"
        }).then(() => {
          window.gAPIAuthInstance = window.gapi.auth2.getAuthInstance(), g(!0);
        }), (N = (E = document == null ? void 0 : document.body) == null ? void 0 : E.removeChild) == null || N.call(E, p);
      };
      p.src = "https://apis.google.com/js/api.js", p.async = !0, p.defer = !0, p.type = "text/javascript", p.onload = $, p.onerror = () => {
        g(!1);
      }, document.body.appendChild(p);
    }
  }, []);
  const u = () => {
    var p;
    window.gAPIAuthInstance && ((p = window.gAPIAuthInstance) == null || p.signIn().then(() => {
      v();
    }));
  }, C = (p) => {
    const $ = y.get("referral_code"), I = y.get("invited_source"), E = {
      ...p,
      ...m,
      email: p.email ? p.email : "",
      social_user_token: p.accessToken,
      social_type: Ee.GOOGLE,
      social_user_id: p.userId,
      source: Re ? "mobile_web" : "web",
      referral_code: $ || void 0,
      invited_source: I || void 0
    };
    p.pictureUrl && (E.avatar = p.pictureUrl);
    const N = (_) => {
      S(_).then((O) => {
        O != null && O.token && f(O);
      });
    };
    if (!E.email) {
      ((O) => {
        Mt({
          social_type: Ee.GOOGLE,
          social_user_id: O.social_user_id
        }).then((M) => {
          var P, w;
          (P = M == null ? void 0 : M.data) != null && P.email ? N({
            ...O,
            email: (w = M == null ? void 0 : M.data) == null ? void 0 : w.email
          }) : (Jt(ta, { data: E }), b());
        }).catch((M) => {
        });
      })(E);
      return;
    }
    N(E);
  }, v = async () => {
    const p = window.gAPIAuthInstance.currentUser.get();
    if (p.hasGrantedScopes("profile")) {
      const I = p.getAuthResponse().id_token;
      typeof window < "u" && window.gapi.client.request({
        method: "GET",
        path: "https://www.googleapis.com/oauth2/v2/userinfo?fields=id,email,family_name,given_name,picture"
      }).execute(function(N) {
        const _ = {
          userId: N.id,
          firstName: N.given_name,
          lastName: N.family_name,
          email: N.email,
          pictureUrl: N.picture,
          accessToken: I,
          socialType: "google",
          redirect: r,
          activeKey: t,
          isLogin: !!n
        };
        C(_);
      });
    }
  };
  return /* @__PURE__ */ A.jsxs(
    at,
    {
      ...c,
      socialType: "google",
      onClick: u,
      useBaseStyle: i,
      children: [
        /* @__PURE__ */ A.jsx(Wi, { color: a ? "#fff" : void 0 }),
        a && /* @__PURE__ */ A.jsx(lt, { isInDropdown: s, text: o.links.google })
      ]
    }
  );
}, pc = (e) => {
  var y;
  const t = Ar(), {
    lang: { getStarted: n },
    handleClick: r,
    isModal: o,
    isInDropdown: a,
    ...i
  } = e, { showTitle: s } = e, c = ot(), f = rt(), S = f.get("referral_code"), d = f.get("invited_source"), g = () => {
    o ? r() : S && d ? c.push(`/${t}/get-started/phone?referral_code=${S}&invited_source=${d}`) : c.push(`/${t}/get-started/phone`);
  };
  return /* @__PURE__ */ A.jsxs(
    at,
    {
      ...i,
      shape: "circle",
      className: He.phoneBtn,
      onClick: () => g(),
      children: [
        /* @__PURE__ */ A.jsx(Gi, {}),
        s && /* @__PURE__ */ A.jsx(lt, { isInDropdown: a, text: (y = n == null ? void 0 : n.links) == null ? void 0 : y.phone })
      ]
    }
  );
}, vc = (e) => {
  var C, v;
  const {
    clientID: t,
    state: n,
    nonce: r,
    scope: o,
    redirectURI: a,
    authCallback: i,
    showTitle: s,
    useBaseStyle: c,
    isInDropdown: f,
    ...S
  } = e, [d, g] = Me(null), y = new Gr(ar), h = ((C = e == null ? void 0 : e.lang) == null ? void 0 : C.getStarted) || {}, m = () => {
    g(null);
  };
  Pe(() => {
    y.onmessage = (p) => {
      if (p.targetOrigin === location.origin) {
        const { type: $, data: I } = p.message;
        $ === ar && (i && i(I), d && d.close(), g(null));
      }
    };
  }, [d]);
  const b = ({ url: p, name: $ }) => {
    if (!p)
      return;
    const I = En({
      url: p,
      name: $
    });
    I && (g(I), nn(Ft), qr({ popup: I, onClose: m }));
  }, u = () => {
    if (en(Ft) && tn(), d)
      if (Re)
        m();
      else {
        d.focus();
        return;
      }
    const I = "https://access.line.me/oauth2/v2.1/authorize?" + Mi.stringify({
      response_type: "code",
      client_id: t,
      state: n,
      scope: o,
      nonce: r,
      prompt: "consent",
      max_age: 120,
      bot_prompt: "normal",
      disable_auto_login: !0
    }) + "&redirect_uri=" + a;
    b({ url: I, name: "Log in with Line" });
  };
  return /* @__PURE__ */ A.jsxs(
    at,
    {
      ...S,
      socialType: "line",
      onClick: u,
      useBaseStyle: c,
      className: He.lineBtn,
      children: [
        /* @__PURE__ */ A.jsx(Xi, { color: c ? "#000" : void 0 }),
        s ? /* @__PURE__ */ A.jsx(lt, { isInDropdown: f, text: (v = h == null ? void 0 : h.links) == null ? void 0 : v.line }) : void 0
      ]
    }
  );
};
function gc(e) {
  const t = na(10), n = ra, r = ot(), o = rt(), a = o.get("referral_code"), i = o.get("invited_source"), s = window.location.origin + "/social-auth-callback/line", c = Xr(s), { defaultLoginCallBack: f, handleAuthSocialLogin: S } = xt(), d = {};
  for (const u of o.entries())
    d[u[0]] = u[1];
  const g = () => {
    r.push("/get-started/connect/email", {
      type: Ee.LINE,
      ...d ?? {}
    });
  }, y = (u) => {
    const C = {
      ...d,
      email: u == null ? void 0 : u.email,
      social_type: Ee.LINE,
      social_user_id: (u == null ? void 0 : u.sub) || "",
      social_user_token: (u == null ? void 0 : u.id_token) || "",
      source: Re ? "mobile_web" : "web",
      referral_code: a || void 0,
      invited_source: i || void 0,
      app_num: oa()
    };
    S(C).then((v) => {
      v != null && v.token && f(v);
    }).finally(() => {
      nn(Ft);
    });
  }, h = (u) => {
    Mt({
      social_type: Ee.LINE,
      social_user_id: u == null ? void 0 : u.sub
    }).then((C) => {
      var v, p;
      (v = C == null ? void 0 : C.data) != null && v.email ? y({ ...u, email: (p = C == null ? void 0 : C.data) == null ? void 0 : p.email }) : g();
    }).catch((C) => {
    });
  }, m = (u) => {
    u != null && u.email ? y(u) : h(u);
  }, b = (u) => {
    const { type: C, data: v } = u;
    C === Yr.SUCCESS ? m(v) : tn();
  };
  return Pe(() => {
    const u = en(Ft);
    u && b(u);
  }, []), /* @__PURE__ */ A.jsx(A.Fragment, { children: /* @__PURE__ */ A.jsx(
    vc,
    {
      clientID: n,
      state: t,
      nonce: t,
      scope: "profile openid email",
      redirectURI: c,
      authCallback: b,
      ...e
    }
  ) });
}
const hc = (e) => {
  var C, v;
  const { authCallback: t, redirect_uri: n, fetchingAuthUrl: r, showTitle: o, useBaseStyle: a, ...i } = e, [s, c] = Me(null), [f, S] = Pi.useMessage(), [d, g] = Me(!1), y = ((C = e == null ? void 0 : e.lang) == null ? void 0 : C.getStarted) || {}, h = new Gr(lr), m = () => {
    c(null);
  };
  Pe(() => {
    h.onmessage = (p) => {
      if (p.targetOrigin === location.origin) {
        const { type: $, data: I } = p.message;
        $ === lr && (t && t(I), s && s.close(), m());
      }
    };
  }, [s]);
  const b = (p) => {
    function $() {
      return new Promise((I) => {
        setTimeout(() => {
          p == null || p.close(), m(), I("close window");
        }, 1e3);
      });
    }
    $().then(() => {
      setTimeout(() => {
        f.open({
          type: "error",
          content: "Third-party login failed, you can try other methods."
        });
      }, 1e3);
    });
  }, u = async () => {
    if (en(Vt) && tn(), s)
      if (Re)
        m();
      else {
        s.focus();
        return;
      }
    r && r(!0);
    let $;
    Re || ($ = En({ url: "", name: "Log in with Twitter" }), c($));
    try {
      if (d)
        return;
      g(!0);
      const I = Qr(), E = await Zi({ redirect_uri: n, app_num: I }), N = (E == null ? void 0 : E.data) || {};
      if (Jt(ia, JSON.stringify(N)), r && r(!1), g(!1), !N.redirect_url) {
        !Re && b($);
        return;
      }
      nn(Vt), Re && ($ = En({ url: N.redirect_url, name: "Log in with Twitter" })), $ && ($.location.href = N.redirect_url, qr({ popup: $, onClose: m }));
    } catch {
      g(!1), !Re && b($), r && r(!1);
    }
  };
  return /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    /* @__PURE__ */ A.jsxs(
      at,
      {
        ...i,
        socialType: "X",
        useBaseStyle: a,
        onClick: u,
        children: [
          /* @__PURE__ */ A.jsx(Yi, { color: a ? "#121212" : void 0 }),
          o ? /* @__PURE__ */ A.jsx(lt, { isInDropdown: e == null ? void 0 : e.isInDropdown, text: (v = y == null ? void 0 : y.links) == null ? void 0 : v.twitter }) : void 0
        ]
      }
    ),
    S
  ] });
};
function bc(e) {
  const t = rt(), n = ot(), r = t.get("referral_code"), o = t.get("invited_source"), { defaultLoginCallBack: a, handleAuthSocialLogin: i } = xt(), s = window.location.origin + "/social-auth-callback/twitter", c = Xr(s), f = {};
  for (const m of t.entries())
    f[m[0]] = m[1];
  const S = () => {
    n.push("/get-started/connect/email", {
      type: Ee.TWITTER,
      ...f ?? {}
    });
  }, d = (m) => {
    const b = {
      ...f,
      email: m == null ? void 0 : m.email,
      social_type: Ee.TWITTER,
      social_user_id: (m == null ? void 0 : m.id) || "",
      social_user_token: (m == null ? void 0 : m.access_token) || "",
      social_user_secret: (m == null ? void 0 : m.access_token_secret) || "",
      source: Re ? "mobile_web" : "web",
      referral_code: r || void 0,
      invited_source: o || void 0,
      app_num: Qr()
    };
    i(b).then((u) => {
      u != null && u.token && a(u);
    }).finally(() => {
      nn(Vt);
    });
  }, g = (m) => {
    Mt({
      social_type: Ee.TWITTER,
      social_user_id: m == null ? void 0 : m.id
    }).then((b) => {
      var u, C;
      (u = b == null ? void 0 : b.data) != null && u.email ? d({
        ...m,
        email: (C = b == null ? void 0 : b.data) == null ? void 0 : C.email
      }) : S();
    }).catch((b) => {
    });
  }, y = (m) => {
    m != null && m.email ? d(m) : g(m);
  }, h = (m) => {
    const { type: b, data: u } = m;
    b === Yr.SUCCESS ? y(u) : tn();
  };
  return Pe(() => {
    const m = en(Vt);
    m && h(m);
  }, []), /* @__PURE__ */ A.jsx(A.Fragment, { children: /* @__PURE__ */ A.jsx(
    hc,
    {
      redirect_uri: c,
      authCallback: h,
      ...e
    }
  ) });
}
const bn = {
  fb: fc,
  x: bc,
  google: mc,
  line: gc,
  email: dc,
  phone: pc,
  apple: ec
}, Cc = ["google", "fb", "email", "phone", "apple", "x"], yc = ["google", "fb", "phone", "email", "apple", "x"], Pr = ["email", "fb", "google", "line", "x", "apple", "phone"], xc = ({
  secondMax: e = 3,
  listItem: t = 3,
  handleEmailClick: n = () => {
  },
  handlePhoneClick: r = () => {
  },
  isModal: o = !1,
  lang: a,
  isPhone: i = !1,
  isEmail: s = !1
}) => {
  const c = window.location.href, f = i || c.includes("get-started/phone"), S = s || c.includes("get-started/email"), d = f || S, [g, y] = Me(!1), h = Si(), m = ["tw"].includes(h);
  let b = [...Cc];
  m && (b = [...Pr]), h === "sg" && (b = [...yc]), h === "jp" && (b = [...Pr]), S && (b = b.filter((E) => !["phone", "email"].includes(E)), b = ["phone", ...b]), f && (b = b.filter((E) => !["phone", "email"].includes(E)), b = ["email", ...b]);
  const [u, C] = [b.splice(0, t), b], v = e + 1 === C.length ? C.length : e, p = () => {
    y(!1);
  }, [$, I] = Me(null);
  return Pe(() => {
    setTimeout(() => {
    });
    const E = document.getElementById("right-container");
    I(E);
  }, []), /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    /* @__PURE__ */ A.jsx(
      "div",
      {
        className: He.socialContent,
        style: { display: "flex", flexDirection: "column", gap: 13 },
        children: u.map((E) => {
          const N = bn[E];
          let _ = E === "email" ? n : E === "phone" ? r : null;
          return _ && s && (_ = n), N ? /* @__PURE__ */ A.jsx(
            N,
            {
              lang: a,
              handleClick: _,
              isModal: o,
              useBaseStyle: d,
              cKey: h,
              showTitle: !0
            },
            E
          ) : null;
        })
      }
    ),
    $ && Mn.createPortal(
      /* @__PURE__ */ A.jsxs(
        "div",
        {
          className: He.socialContentBottom,
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            gap: 24,
            marginTop: Re && !o ? 171 : void 0
          },
          children: [
            /* @__PURE__ */ A.jsx("div", { className: He.or, children: "or" }),
            C.slice(0, v).map((E) => {
              let N = E === "email" ? n : E === "phone" ? r : null;
              N && s && (N = n);
              const _ = bn[E];
              let O = "";
              switch (E) {
                case "email":
                  O = a.getStarted.links.email;
                  break;
                case "phone":
                  O = a.getStarted.links.phone;
                  break;
                case "google":
                  O = a.getStarted.links.google;
                  break;
                case "fb":
                  O = a.getStarted.links.facebook;
                  break;
                case "line":
                  O = a.getStarted.links.line;
                  break;
                case "x":
                  O = a.getStarted.links.twitter;
                  break;
                case "apple":
                  O = a.getStarted.links.apple;
                  break;
              }
              return _ ? /* @__PURE__ */ A.jsxs(Vr, { title: O, children: [
                /* @__PURE__ */ A.jsx(
                  _,
                  {
                    showTitle: !1,
                    useBaseStyle: !0,
                    lang: a,
                    isModal: o,
                    handleClick: N,
                    shape: "circle",
                    cKey: h
                  }
                ),
                /* @__PURE__ */ A.jsx("i", { style: { display: "none" }, children: E })
              ] }, E) : null;
            }),
            C.length > e + 1 && /* @__PURE__ */ A.jsx(A.Fragment, { children: /* @__PURE__ */ A.jsx(
              Hs,
              {
                overlayStyle: { zIndex: 99999 },
                open: g,
                trigger: ["click", "hover"],
                onOpenChange: (E) => {
                  y(E);
                },
                placement: "topRight",
                dropdownRender: () => /* @__PURE__ */ A.jsx("div", { className: He.loginMoreDropdown, children: C.slice(v).map((E) => {
                  const N = bn[E];
                  return N ? (
                    // <Tooltip key={v} title={tipText}>
                    /* @__PURE__ */ A.jsx(
                      N,
                      {
                        isInDropdown: !0,
                        className: "login-dropdown-item",
                        onClickCapture: p,
                        lang: a,
                        useBaseStyle: d,
                        showTitle: !0
                      },
                      E
                    )
                  ) : null;
                }) }),
                children: /* @__PURE__ */ A.jsx("div", { className: He.loginMoreBtn, children: /* @__PURE__ */ A.jsx(qi, {}) })
              }
            ) })
          ]
        }
      ),
      $
    )
  ] });
};
export {
  Ke as F,
  xc as L
};
//# sourceMappingURL=LoginOpt-7adb4d9a.js.map
